<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="950"
    v-model="visible"
    :confirmLoading="confirmLoading"
   :footer="false"
    :maskClosable="false"
  >

    <div v-if="types==0">

      <div v-if="type==7">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件单类型"  >
          <a-select  @change="onchange" v-model="commonFlag"  >
            <a-select-option value="0">调货</a-select-option>
            <a-select-option value="1">退货</a-select-option>
            <a-select-option value="2">调拨</a-select-option>
            <a-select-option value="3">报损</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>

<!--      调货流程-->
    <div v-if="type==0" >
      <div>
        <div v-if="parts2==0">
        <!-- 正常流程标题 -->
          <a-steps :current="current">
            <a-step v-for="item in steps" :key="item.title" :title="item.title" />
          </a-steps>
        </div>
<!--        后付款流程标题-->
        <div v-if="parts2==1">
          <a-steps :current="current2">
            <a-step v-for="item in steps2" :key="item.title" :title="item.title" />
          </a-steps>

        </div>

        <!-- 配发标题 -->
        <div v-if="parts2==2">
          <a-steps :current="current3">
            <a-step v-for="item in steps3" :key="item.title" :title="item.title" />
          </a-steps>

        </div>

        <div class="steps-action" >





          <!--  先付款  第一步-->
          <div v-if="current==0 && dispatch==0">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号">
                <a-input v-model="shippingNo"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"  v-model="payment"  >
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice" >
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>



              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark"/>
              </a-form-item>


              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
                <a-select  @change="onChange3" v-model="accessoryId" >
                  <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
                <a-input   v-model="unityPrice"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input  v-model="accessoryNumber" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件总价">
                <a-input   v-model="price2"  @click="clickMe" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark" />
              </a-form-item>
            </a-form>
            <a-button class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <span>
              <a-upload
                name="file"
                :fileList="fileList1"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
          <!-- 后付款   第一步-->
          <div v-if="current2==0 && dispatch==1">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号">
                <a-input v-model="shippingNo"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage44" v-model="originStoreId" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage33" v-model="storeId" >
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"  v-model="payment"  >
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice" >
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>



              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark"/>
              </a-form-item>



              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
                <a-select  @change="onChange3" v-model="accessoryId" >
                  <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
                <a-input   v-model="unityPrice"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input  v-model="accessoryNumber" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件总价">
                <a-input   v-model="price2"  @click="clickMe" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark" />
              </a-form-item>
            </a-form>
            <a-button class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <span>
              <a-upload
                name="file"
                :fileList="fileList1"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
           <!-- 发配   第一步-->
          <div v-if="current3==0 && dispatch==2">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号">
                <a-input v-model="shippingNo"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage44" v-model="originStoreId" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage33" v-model="storeId" >
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"  v-model="payment"  >
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice" >
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>



              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark"/>
              </a-form-item>


              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
                <a-select  @change="onChange3" v-model="accessoryId" >
                  <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
                <a-input   v-model="unityPrice"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input  v-model="accessoryNumber" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件总价">
                <a-input   v-model="price2"  @click="clickMe" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark" />
              </a-form-item>
            </a-form>
            <a-button class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <span>
              <a-upload
                name="file"
                :fileList="fileList1"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>
          </div>



          <!-- 先付款 第二步-->
          <div v-if="current==1 && dispatch==0">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId"  disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem" v-model="needTime"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>


              <div>调货内容</div>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>

            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>


            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名" style="position: relative">
                <span style="color: red;position: absolute;left: -65px;">*</span>
                <a-input  v-model="accountName" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-input v-model="accountNumber" autocomplete="off"  v-decorator="[
                    'accountNumber',
                    { rules: [{validator: this.bankNum,required: false}] },
                    ]" />

              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行" style="position: relative">
                <span style="color: red;position: absolute;left: -65px;">*</span>
                <!--<a-input  v-model="bankName" />-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" style="position: relative">
              <span style="color: red;position: absolute;left: -105px;">*</span>
              <a-date-picker    @change="onChangeTiem2"  />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" style="position: relative">
              <span style="color: red;position: absolute;left: -105px;">*</span>
              <a-date-picker     @change="onChangeTiem3"  />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
              <a-input  v-model="paymentRemark" />
            </a-form-item>

            </a-form>

            <span>
              <a-upload
                name="file"
                :fileList="fileList2"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
          <!--  后付款  第二步-->
          <div v-if="current2==1 && dispatch==1 ">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库ID">
                <a-select  @change="onchage44" v-model="storeId"  disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem" v-model="needTime"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>


              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>


            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"   >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"   >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>



            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" >添加物流信息</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportCode"  >
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-input v-model="item.transportNo" />
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportStatus" >
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <!--                    <a-select-option :value="2">确认收货</a-select-option>-->
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-button type="danger" ghost  @click="removeTab1(item)" >删除</a-button>
              </a-form-item>

          </div>

              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"    />
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark" />
              </a-form-item>
            </a-form>
            <span>
              <a-upload
                name="file"
                :fileList="fileList2"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
          <!-- 发配   第二步-->
          <div v-if="current3==1 && dispatch==2 ">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库ID">
                <a-select  @change="onchage44" v-model="storeId"  disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem" v-model="needTime" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>

              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>
            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" >添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportCode"  >
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-input v-model="item.transportNo" />
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportStatus" >
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <!--                    <a-select-option :value="2">确认收货</a-select-option>-->
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" >删除</a-button>
                </a-form-item>
              </div>

              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"    />
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark"  />
              </a-form-item>
            </a-form>
            <span>
              <a-upload
                name="file"
                :fileList="fileList2"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>



          <!--先付款 第三步-->
          <div v-if="current==2 && dispatch==0">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>
              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>
            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>


            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
                <a-input  v-model="accountName"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
                <a-input  v-model="accountNumber" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
                <!--<a-input  v-model="bankName" disabled="disabled"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  disabled="disabled"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" >
                <a-date-picker      @change="onChangeTiem2"   v-model="paymentTimeBegin"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" >
                <a-date-picker     @change="onChangeTiem3"  v-model="paymentTimeEnd" disabled="disabled"/>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form3">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" style="position: relative">
              <span style="color: red;position: absolute;left: -105px;">*</span>
              <a-date-picker       @change="onChangeTiem4"   />
              <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
              <a-input  v-model="paymentCompletionRemark" />
            </a-form-item>
            </a-form>
            <span>
              <a-upload
                name="file"
                :fileList="fileList3"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
          <!--  后付款  第三步-->
          <div v-if="current2==2 && dispatch==1">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>

              <div>调货内容</div>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>


            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>
            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportCode"  disabled="disabled">
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="item.transportNo" disabled="disabled"/>
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportStatus" disabled="disabled">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" disabled="disabled">删除</a-button>
                </a-form-item>
              </div>

              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark"  disabled="disabled"/>
              </a-form-item>
            </a-form>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名" style="position: relative">
                <span style="color: red;position: absolute;left: -65px;">*</span>
                <a-input  v-model="accountName" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-input v-model="accountNumber" autocomplete="off"  v-decorator="[
                    'accountNumber',
                    { rules: [{validator: this.bankNum,required: false}] },
                    ]" />

              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行" style="position: relative">
                <span style="color: red;position: absolute;left: -65px;">*</span>
                <!--<a-input  v-model="bankName" />-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker    @change="onChangeTiem2"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker     @change="onChangeTiem3"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark" />
              </a-form-item>

            </a-form>

            <span>
              <a-upload
                name="file"
                :fileList="fileList3"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>
          </div>
          <!-- 发配   第三步-->
          <div v-if="current3==2 && dispatch==2">
            <div>调货单2222</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>

              <div>调货内容</div>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>

            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportCode"  disabled="disabled">
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="item.transportNo" disabled="disabled"/>
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportStatus" disabled="disabled">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" disabled="disabled">删除</a-button>
                </a-form-item>
              </div>

              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>
            <a-form :form="form5">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单完成时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker  format="YYYY-MM-DD"     @change="onChangeTiem5"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark"  />
              </a-form-item>
            </a-form>

<!--            <a-button style="float: right"  type="primary" @click="returnGoods">-->
<!--              退货-->
<!--            </a-button>-->
          </div>



         <!--先付款 第四步-->
          <div v-if="current==3 && dispatch==0">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>


              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>
            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
                <a-input  v-model="accountName"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
                <a-input  v-model="accountNumber" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
                <!--<a-input  v-model="bankName" disabled="disabled"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  disabled="disabled"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" >
                <a-date-picker      @change="onChangeTiem2"  v-model="paymentTimeBegin"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" >
                <a-date-picker     @change="onChangeTiem3" v-model="paymentTimeEnd"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>


            <a-form :form="form3">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" >
                <a-date-picker  format="YYYY-MM-DD"     @change="onChangeTime5" v-model="paymentCompletionTime"   disabled="disabled"/>
                <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
                <a-input  v-model="paymentCompletionRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists3"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" >添加物流信息</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportCode"  >
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-input v-model="item.transportNo" />
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportStatus" >
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
<!--                    <a-select-option :value="2">确认收货</a-select-option>-->
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" >删除</a-button>
                </a-form-item>
              </div>
              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"    />
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark" />
              </a-form-item>
            </a-form>
            </a-form>

            <span>
              <a-upload
                name="file"
                :fileList="fileList4"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>


          </div>
          <!-- 后付款 第四步-->
          <div v-if="current2==3 && dispatch==1"  >
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>



              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>

            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportCode"  disabled="disabled">
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="item.transportNo" disabled="disabled"/>
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportStatus" disabled="disabled">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" disabled="disabled">删除</a-button>
                </a-form-item>
              </div>

              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark"  disabled="disabled"/>
              </a-form-item>
            </a-form>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>
            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
                <a-input  v-model="accountName"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
                <a-input  v-model="accountNumber" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
                <!--<a-input  v-model="bankName" disabled="disabled"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  disabled="disabled"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" >
                <a-date-picker      @change="onChangeTiem2"  v-model="paymentTimeBegin" disabled="disabled"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" >
                <a-date-picker     @change="onChangeTiem3" v-model="paymentTimeEnd" disabled="disabled"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists3"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>


            <a-form :form="form3">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker       @change="onChangeTiem4"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
                <a-input  v-model="paymentCompletionRemark" />
              </a-form-item>
            </a-form>

            <span>
              <a-upload
                name="file"
                :fileList="fileList4"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>
          </div>



         <!-- 先付款 第五步-->
          <div v-if="current==4 && dispatch==0">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage33" v-model="storeId" disabled="disabled" >
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>


              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>

            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
                <a-input  v-model="accountName"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
                <a-input  v-model="accountNumber" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
                <!--<a-input  v-model="bankName" disabled="disabled"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  disabled="disabled"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" >
                <a-date-picker      @change="onChangeTiem2"  v-model="paymentTimeBegin"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" >
                <a-date-picker     @change="onChangeTiem3" v-model="paymentTimeEnd"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form3">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" >
                <a-date-picker  format="YYYY-MM-DD"     @change="onChangeTime4" v-model="paymentCompletionTime"  disabled="disabled"/>
                <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
                <a-input  v-model="paymentCompletionRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists3"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportCode"  disabled="disabled">
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="item.transportNo" disabled="disabled"/>
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportStatus" disabled="disabled">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" disabled="disabled">删除</a-button>
                </a-form-item>
              </div>

              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists4"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>
            <a-form :form="form5">

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单完成时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker  format="YYYY-MM-DD"     @change="onChangeTiem5"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark"  />
              </a-form-item>
            </a-form>
<!--            <a-button style="left: 200px"  type="primary" @click="warehousing">-->
<!--              入库-->
<!--            </a-button>-->
<!--            <a-button style="float: right"  type="primary" @click="returnGoods">-->
<!--             退货-->
<!--            </a-button>-->
          </div>
          <!-- 后付款 第五步-->
          <div v-if="current2==4 && dispatch==1">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage33" v-model="storeId" disabled="disabled" >
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>



              <div>调货内容</div>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>

            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>


            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportCode"  disabled="disabled">
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="item.transportNo" disabled="disabled"/>
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportStatus" disabled="disabled">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" disabled="disabled">删除</a-button>
                </a-form-item>
              </div>

              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark"  disabled="disabled"/>
              </a-form-item>
            </a-form>


            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
                <a-input  v-model="accountName"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
                <a-input  v-model="accountNumber" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
                <!--<a-input  v-model="bankName" disabled="disabled"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  disabled="disabled"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" >
                <a-date-picker      @change="onChangeTiem2" v-model="paymentTimeBegin"   disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" >
                <a-date-picker     @change="onChangeTiem3" v-model="paymentTimeEnd"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>


            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists3"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form3">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" >
                <a-date-picker       @change="onChangeTime5"   v-model="paymentCompletionTime" disabled="disabled"/>
                <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
                <a-input  v-model="paymentCompletionRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists4"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>
            <a-form :form="form5">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单完成时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker  format="YYYY-MM-DD"     @change="onChangeTiem5"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark"  />
              </a-form-item>
            </a-form>

            <a-button style="float: right"  type="primary" @click="returnGoods">
              退货
            </a-button>
          </div>


           <!--先付款-->
          <div v-if="parts2==0">
            <a-button v-if="current < steps.length - 1" type="primary" @click="next">
              下一步
            </a-button>
            <a-button
              v-if="current == steps.length - 1"
              type="primary"
              @click="next"
            >
              确定
            </a-button>
            <a-button v-if="current > 0" style="margin-left: 8px" @click="prev">
              上一步
            </a-button>
   </div>
          <!--后付款-->
          <div v-if="parts2==1">
            <a-button v-if="current2 < steps2.length - 1" type="primary" @click="next2">
              下一步
            </a-button>
            <a-button
              v-if="current2 == steps2.length - 1"
              type="primary"
              @click="next2"
            >
              确定
            </a-button>
            <a-button v-if="current2 > 0" style="margin-left: 8px" @click="prev2">
              上一步
            </a-button>
          </div>
          <!--发配-->
          <div v-if="parts2==2">
            <a-button v-if="current3 < steps3.length - 1" type="primary" @click="next3">
              下一步
            </a-button>
            <a-button
              v-if="current3 == steps3.length - 1"
              type="primary"
              @click="next3"
            >
              确定
            </a-button>
            <a-button v-if="current3 > 0" style="margin-left: 8px" @click="prev3">
              上一步
            </a-button>
          </div>
        </div>
      </div>
    </div>





<!--    报损-->
     <div v-if="type==3" >
            <div>报损单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损单号">
                <a-input v-model="backOrderNo"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="库存类型">
                <a-input v-model="storeId"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损仓库">
                <a-input v-model="storeId"/>
              </a-form-item>

              <div>退货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
                <a-select  @change="selectstore2" v-model="accessoryId" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损数量">
                <a-input   v-model="unityPrice"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损原因">
                <a-input  v-model="accessoryNumber" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="损失承担方">
                <a-input  v-model="price2"  @click="clickMe" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="损失承担人">
                <a-input v-model="totalPrice"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任人">
                <a-input v-model="remark" />
              </a-form-item>
            </a-form>
            <a-button class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns4">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>
    </div>

<!--  查看  -->
    <div v-if="types==5">
      <div v-if="type==7">
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件单类型">
            <a-select  @change="onchange" v-model="commonFlag"  >
              <a-select-option value="0">调货</a-select-option>
              <a-select-option value="1">退货</a-select-option>
              <a-select-option value="2">调拨</a-select-option>
              <a-select-option value="3">报损</a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </div>
      <div v-if="type==0" >
        <div>
        <div v-if="parts2==0">
          <!-- 正常流程标题 -->
          <a-steps :current="current">
            <a-step v-for="item in steps" :key="item.title" :title="item.title" />
          </a-steps>
        </div>
        <!--        后付款流程标题-->
        <div v-if="parts2==1">
          <a-steps :current="current2">
            <a-step v-for="item in steps2" :key="item.title" :title="item.title" />
          </a-steps>

        </div>

        <!-- 配发标题 -->
        <div v-if="parts2==2">
          <a-steps :current="current3">
            <a-step v-for="item in steps3" :key="item.title" :title="item.title" />
          </a-steps>

        </div>

        <div class="steps-action" >





          <!--  先付款  第一步-->
          <div v-if="current==0 && dispatch==0">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号">
                <a-input v-model="shippingNo"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"  v-model="payment"  >
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice" >
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>



              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark"/>
              </a-form-item>


              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
                <a-select  @change="onChange3" v-model="accessoryId" >
                  <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
                <a-input   v-model="unityPrice"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input  v-model="accessoryNumber" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件总价">
                <a-input   v-model="price2"  @click="clickMe" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark" />
              </a-form-item>
            </a-form>
            <a-button class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <span>
              <a-upload
                name="file"
                :fileList="fileList1"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
          <!-- 后付款   第一步-->
          <div v-if="current2==0 && dispatch==1">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号">
                <a-input v-model="shippingNo"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage44" v-model="originStoreId" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage33" v-model="storeId" >
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"  v-model="payment"  >
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice" >
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>



              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark"/>
              </a-form-item>



              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
                <a-select  @change="onChange3" v-model="accessoryId" >
                  <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
                <a-input   v-model="unityPrice"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input  v-model="accessoryNumber" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件总价">
                <a-input   v-model="price2"  @click="clickMe" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark" />
              </a-form-item>
            </a-form>
            <a-button class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <span>
              <a-upload
                name="file"
                :fileList="fileList1"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
          <!-- 发配   第一步-->
          <div v-if="current3==0 && dispatch==2">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号">
                <a-input v-model="shippingNo"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage44" v-model="originStoreId" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage33" v-model="storeId" >
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"  v-model="payment"  >
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice" >
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>



              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark"/>
              </a-form-item>


              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
                <a-select  @change="onChange3" v-model="accessoryId" >
                  <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
                <a-input   v-model="unityPrice"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input  v-model="accessoryNumber" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件总价">
                <a-input   v-model="price2"  @click="clickMe" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark" />
              </a-form-item>
            </a-form>
            <a-button class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <span>
              <a-upload
                name="file"
                :fileList="fileList1"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>
          </div>



          <!-- 先付款 第二步-->
          <div v-if="current==1 && dispatch==0">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId"  disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem" v-model="needTime"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>


              <div>调货内容</div>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>

            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>


            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名" style="position: relative">
                <span style="color: red;position: absolute;left: -65px;">*</span>
                <a-input  v-model="accountName" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-input v-model="accountNumber" autocomplete="off"  v-decorator="[
                    'accountNumber',
                    { rules: [{validator: this.bankNum,required: false}] },
                    ]" />

              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行" style="position: relative">
                <span style="color: red;position: absolute;left: -65px;">*</span>
                <!--<a-input  v-model="bankName" />-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker    @change="onChangeTiem2"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker     @change="onChangeTiem3"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark" />
              </a-form-item>

            </a-form>

            <span>
              <a-upload
                name="file"
                :fileList="fileList2"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
          <!--  后付款  第二步-->
          <div v-if="current2==1 && dispatch==1 ">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库ID">
                <a-select  @change="onchage44" v-model="storeId"  disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem" v-model="needTime"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>


              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>


            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"   disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"   disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"  disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>



            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" >添加物流信息</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportCode"  >
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-input v-model="item.transportNo" />
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportStatus" >
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <!--                    <a-select-option :value="2">确认收货</a-select-option>-->
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" >删除</a-button>
                </a-form-item>
              </div>
              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>
            <span>
              <a-upload
                name="file"
                :fileList="fileList2"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
          <!-- 发配   第二步-->
          <div v-if="current3==1 && dispatch==2 ">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库ID">
                <a-select  @change="onchage44" v-model="storeId"  disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem" v-model="needTime" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>

              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>
            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" >添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportCode"  >
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-input v-model="item.transportNo" />
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportStatus" >
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <!--                    <a-select-option :value="2">确认收货</a-select-option>-->
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" >删除</a-button>
                </a-form-item>
              </div>
              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark" disabled="disabled"/>
              </a-form-item>

            </a-form>
            <span>
              <a-upload
                name="file"
                :fileList="fileList2"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>



          <!--先付款 第三步-->
          <div v-if="current==2 && dispatch==0">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>
              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>
            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>


            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
                <a-input  v-model="accountName"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
                <a-input  v-model="accountNumber" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
                <!--<a-input  v-model="bankName" disabled="disabled"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  disabled="disabled"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" >
                <a-date-picker      @change="onChangeTiem2"   v-model="paymentTimeBegin"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" >
                <a-date-picker     @change="onChangeTiem3"  v-model="paymentTimeEnd" disabled="disabled"/>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form3">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker       @change="onChangeTiem4"   />
                <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
                <a-input  v-model="paymentCompletionRemark" />
              </a-form-item>
            </a-form>
            <span>
              <a-upload
                name="file"
                :fileList="fileList3"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
          <!--  后付款  第三步-->
          <div v-if="current2==2 && dispatch==1">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>

              <div>调货内容</div>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>


            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>
            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportCode"  disabled="disabled">
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="item.transportNo" disabled="disabled"/>
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportStatus" disabled="disabled">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" disabled="disabled">删除</a-button>
                </a-form-item>
              </div>
              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名" style="position: relative">
                <span style="color: red;position: absolute;left: -65px;">*</span>
                <a-input  v-model="accountName" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-input v-model="accountNumber" autocomplete="off"  v-decorator="[
                    'accountNumber',
                    { rules: [{validator: this.bankNum,required: false}] },
                    ]" />

              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行" style="position: relative">
                <span style="color: red;position: absolute;left: -65px;">*</span>
                <!--<a-input  v-model="bankName" />-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker    @change="onChangeTiem2"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker     @change="onChangeTiem3"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark" />
              </a-form-item>

            </a-form>

            <span>
              <a-upload
                name="file"
                :fileList="fileList3"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>
          </div>
          <!-- 发配   第三步-->
          <div v-if="current3==2 && dispatch==2">
            <div>调货单333</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>

              <div>调货内容</div>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>

            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportCode"  disabled="disabled">
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="item.transportNo" disabled="disabled"/>
                </a-form-item>

                <div v-if="operateTransport==2">
                  <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select   v-model="item.transportStatus" >
                      <a-select-option :value="0">未发货</a-select-option>
                      <a-select-option :value="1">发货中</a-select-option>
                      <a-select-option :value="2">确认收货</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <div v-if="operateTransport !=2">
                  <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select   v-model="item.transportStatus" disabled="disabled" >
                      <a-select-option :value="0">未发货</a-select-option>
                      <a-select-option :value="1">发货中</a-select-option>
                      <a-select-option :value="2">确认收货</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" disabled="disabled">删除</a-button>
                </a-form-item>
              </div>
              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)" >启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)" >禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>
            <a-form :form="form5">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单完成时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker  format="YYYY-MM-DD"     @change="onChangeTiem5"    v-model="orderCompletionTime" />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark"  />
              </a-form-item>
            </a-form>

          </div>



          <!--先付款 第四步-->
          <div v-if="current==3 && dispatch==0">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>


              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>
            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
                <a-input  v-model="accountName"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
                <a-input  v-model="accountNumber" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
                <!--<a-input  v-model="bankName" disabled="disabled"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  disabled="disabled"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" >
                <a-date-picker      @change="onChangeTiem2"  v-model="paymentTimeBegin"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" >
                <a-date-picker     @change="onChangeTiem3" v-model="paymentTimeEnd"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>


            <a-form :form="form3">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" >
                <a-date-picker  format="YYYY-MM-DD"     @change="onChangeTime5" v-model="paymentCompletionTime"   disabled="disabled"/>
                <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
                <a-input  v-model="paymentCompletionRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists3"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" >添加物流信息</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportCode"  >
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-input v-model="item.transportNo" />
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                  <span style="color: red;position: absolute;left: -78px;">*</span>
                  <a-select   v-model="item.transportStatus" >
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <!--                    <a-select-option :value="2">确认收货</a-select-option>-->
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" >删除</a-button>
                </a-form-item>
              </div>
              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>

            <span>
              <a-upload
                name="file"
                :fileList="fileList4"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>


          </div>
          <!-- 后付款 第四步-->
          <div v-if="current2==3 && dispatch==1">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>



              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>

            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportCode"  disabled="disabled">
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="item.transportNo" disabled="disabled"/>
                </a-form-item>

                <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportStatus" disabled="disabled">
                    <a-select-option :value="0">未发货</a-select-option>
                    <a-select-option :value="1">发货中</a-select-option>
                    <a-select-option :value="2">确认收货</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" disabled="disabled">删除</a-button>
                </a-form-item>
              </div>
              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>
            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
                <a-input  v-model="accountName"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
                <a-input  v-model="accountNumber" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
                <!--<a-input  v-model="bankName" disabled="disabled"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  disabled="disabled"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" >
                <a-date-picker      @change="onChangeTiem2"  v-model="paymentTimeBegin" disabled="disabled"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" >
                <a-date-picker     @change="onChangeTiem3" v-model="paymentTimeEnd" disabled="disabled"  />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists3"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>


            <a-form :form="form3">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker       @change="onChangeTiem4"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
                <a-input  v-model="paymentCompletionRemark" />
              </a-form-item>
            </a-form>

            <span>
              <a-upload
                name="file"
                :fileList="fileList4"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>
          </div>



          <!-- 先付款 第五步-->
          <div v-if="current==4 && dispatch==0">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>


              <div>调货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>

            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
                <a-input  v-model="accountName"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
                <a-input  v-model="accountNumber" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
                <!--<a-input  v-model="bankName" disabled="disabled"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  disabled="disabled"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" >
                <a-date-picker      @change="onChangeTiem2"  v-model="paymentTimeBegin"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" >
                <a-date-picker     @change="onChangeTiem3" v-model="paymentTimeEnd"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form3">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" >
                <a-date-picker  format="YYYY-MM-DD"     @change="onChangeTime4" v-model="paymentCompletionTime"  disabled="disabled"/>
                <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
                <a-input  v-model="paymentCompletionRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists3"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportCode"  disabled="disabled">
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="item.transportNo" disabled="disabled"/>
                </a-form-item>

                <div v-if="operateTransport==2">
                  <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select   v-model="item.transportStatus" >
                      <a-select-option :value="0">未发货</a-select-option>
                      <a-select-option :value="1">发货中</a-select-option>
                      <a-select-option :value="2">确认收货</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <div v-if="operateTransport !=2">
                  <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select   v-model="item.transportStatus" disabled="disabled" >
                      <a-select-option :value="0">未发货</a-select-option>
                      <a-select-option :value="1">发货中</a-select-option>
                      <a-select-option :value="2">确认收货</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" disabled="disabled">删除</a-button>
                </a-form-item>
              </div>
              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark" disabled="disabled"/>
              </a-form-item>

            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists4"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>
            <a-form :form="form5">

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单完成时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker  format="YYYY-MM-DD"     @change="onChangeTiem5"   v-model="orderCompletionTime"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark"  disabled="disabled" />
              </a-form-item>
            </a-form>

          </div>
          <!-- 后付款 第五步-->
          <div v-if="current2==4 && dispatch==1">
            <div>调货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号" >
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库">
                <a-select  @change="onchage33" v-model="originStoreId" disabled="disabled">
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库">
                <a-select  @change="onchage44" v-model="storeId" disabled="disabled">
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                <a-select @change="onChange2"   v-model="payment"   disabled="disabled">
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票">
                <a-select v-model="invoice"  disabled="disabled">
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间">
                <a-date-picker  @change="onChangeTiem"  v-model="needTime" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨备注">
                <a-input v-model="shippingRemark" disabled="disabled"/>
              </a-form-item>



              <div>调货内容</div>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
                <a-input  v-model="totalPrice"  disabled="disabled" />
              </a-form-item>

            </a-form>
            <a-button disabled="disabled" class="editable-add-btn" @click="handleAdd">添加</a-button>
            <a-table bordered :dataSource="dataSource" :columns="columns">
              <template slot="name" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除吗?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;" disabled="disabled">删除</a>
                </a-popconfirm>
              </template>
            </a-table>


            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form4">
                  <span>
                  <a-button  style="width:110px;margin-left: 60%;" type="primary" ghost @click="handleadd1" disabled="disabled">添加</a-button>
                </span>
              <div v-for="(item,i) in logistics" :key="i">

                <a-form-item label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select   v-model="item.transportCode"  disabled="disabled">
                    <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model="item.transportNo" disabled="disabled"/>
                </a-form-item>

                <div v-if="operateTransport==2">
                  <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select   v-model="item.transportStatus" >
                      <a-select-option :value="0">未发货</a-select-option>
                      <a-select-option :value="1">发货中</a-select-option>
                      <a-select-option :value="2">确认收货</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <div v-if="operateTransport !=2">
                  <a-form-item label="物流状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select   v-model="item.transportStatus" disabled="disabled" >
                      <a-select-option :value="0">未发货</a-select-option>
                      <a-select-option :value="1">发货中</a-select-option>
                      <a-select-option :value="2">确认收货</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <a-form-item  label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-button type="danger" ghost  @click="removeTab1(item)" disabled="disabled">删除</a-button>
                </a-form-item>
              </div>
              <a-form-item  label="预计到货时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="position: relative">
                <span style="color: red;position: absolute;left: -107px;">*</span>
                <a-date-picker  @change="onChangeTiem66"  v-model="expectedDeliveryTime"   disabled="disabled"/>
              </a-form-item>

              <a-form-item  label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="transportRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>


            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists2"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form2">
              <a-form-item style="display:none">
                <a-input v-decorator="['purchaseOrderId']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户名">
                <a-input  v-model="accountName"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行卡号">
                <a-input  v-model="accountNumber" disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
                <!--<a-input  v-model="bankName" disabled="disabled"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="bankName"
                  :filterOption="filterOption"
                  disabled="disabled"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>


              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款开始时间" >
                <a-date-picker      @change="onChangeTiem2" v-model="paymentTimeBegin"   disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款结束时间" >
                <a-date-picker     @change="onChangeTiem3" v-model="paymentTimeEnd"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款备注">
                <a-input  v-model="paymentRemark"  disabled="disabled"/>
              </a-form-item>

            </a-form>


            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists3"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>

            <a-form :form="form3">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成时间" >
                <a-date-picker       @change="onChangeTime5"   v-model="paymentCompletionTime" disabled="disabled"/>
                <!--        <a-input v-decorator="['purchaseOrderNo', {rules: [{required: true, message: '请输入采购单号'}]}]"/>-->
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款完成备注">
                <a-input  v-model="paymentCompletionRemark" disabled="disabled"/>
              </a-form-item>
            </a-form>

            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="columns7"
              :dataSource="fileLists4"
              bordered
            >
                      <span slot="action2" slot-scope="text, record">
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.forbiddenStatus == 1" @click="disableContract(record)"  disabled="disabled">启用</a>
                        <a v-if="record.forbiddenStatus == 0" @click=" enableContract(record)"  disabled="disabled">禁用</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                          title="确认删除吗？" disabled="disabled"
                          @confirm="() => delContract(record)"
                        >
                          <a href="javascript:;">删除</a>
                        </a-popconfirm>
                      </span>
            </a-table>
            <a-form :form="form5">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单完成时间" style="position: relative">
                <span style="color: red;position: absolute;left: -105px;">*</span>
                <a-date-picker  format="YYYY-MM-DD"     @change="onChangeTiem5"  v-model="orderCompletionTime"  disabled="disabled"/>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input   v-model="remark" disabled="disabled" />
              </a-form-item>
            </a-form>

          </div>

          <span style="display: flex;justify-content: flex-end;">
         <a-button @click="handleSubmit2" >取消</a-button>
<!--      <a-button @click="handleSubmit" type="primary">确认</a-button>-->
        </span>
        </div>
      </div>
    </div>

    </div>




<!-- 选择判断-->
    <div v-if="types==1">
      <div v-if="type==7">
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件单类型"  style="position: relative">
            <span style="color: red;position: absolute;left: -92px;">*</span>
            <a-select  @change="onchange" v-model="commonFlag"  >
              <a-select-option value="0">调货</a-select-option>
              <a-select-option value="1">退货</a-select-option>
              <a-select-option value="2">调拨</a-select-option>
              <a-select-option value="3">报损</a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </div>

      <!--      调货-->
      <div v-if="type==0 " >
        <!--  调货单 -->
          <div>调货单</div>
          <a-form :form="form">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调货单号">
              <a-input v-model="shippingNo" disabled="disabled"/>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库" style="position: relative">
              <span style="color: red;position: absolute;left: -78px;">*</span>
              <a-input   v-model="invoiceNmae"  disabled="disabled" />
<!--              <a-select  @change="onchage33" v-model="originStoreId" >-->
<!--                <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>-->
<!--              </a-select>-->
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库" style="position: relative">
              <span style="color: red;position: absolute;left: -78px;">*</span>
              <a-select  @change="onchage44" v-model="storeId" >
                <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式" style="position: relative">
              <span style="color: red;position: absolute;left: -78px;">*</span>
              <a-select @change="onChange2"  v-model="payment"  >
                <a-select-option value="0">先付款</a-select-option>
                <a-select-option value="1">后付款</a-select-option>
                <a-select-option value="2">配发</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票" style="position: relative">
              <span style="color: red;position: absolute;left: -78px;">*</span>
              <a-select v-model="invoice" >
                <a-select-option value="0">否</a-select-option>
                <a-select-option value="1">是</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间" style="position: relative">
              <span style="color: red;position: absolute;left: -78px;">*</span>
              <a-date-picker  @change="onChangeTiem"  />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input v-model="shippingRemark"/>
            </a-form-item>


            <div>调货内容</div>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
              <a-select  @change="onChange3" v-model="accessoryId" >
                <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
              <a-input   v-model="unityPrice"   />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
              <a-input  v-model="accessoryNumber"  @blur="blur(accessoryNumber)" type="number" min="0"/>
            </a-form-item>



            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购总金额">
              <a-input  v-model="orderPrice"  disabled="disabled"/>
            </a-form-item>


          </a-form>
          <a-button class="editable-add-btn" @click="handleAdd">添加</a-button>
          <a-table bordered :dataSource="dataSource" :columns="columns">
            <template slot="totalPrice" slot-scope="text, record">
              <editable-cell :text="text" @change="onCellChange(record.key, 'totalPrice', $event)" />
            </template>



            <template slot="remark" slot-scope="text, record">
              <editable-cell :text="text" @change="onCellChange(record.key, 'remark', $event)" />
            </template>
            <template slot="operation" slot-scope="text, record">
              <a-popconfirm
                v-if="dataSource.length"
                title="确定删除吗?"
                @confirm="() => onDelete(record.key)"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>

        <span>
              <a-upload
                name="file"
                :fileList="fileList1"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

        </div>

        <!--          退货-->
        <div v-if="type==1 " >
            <div>退货单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="退货单号">
                <a-input v-model="backOrderNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="退货仓库" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-select  @change="onchage33" v-model="originStoreId" >
                  <a-select-option   v-for=" item in selectstore2" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货仓库" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-select  @change="onchage44" v-model="storeId" >
                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="退款方式" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-select @change="onChange2"  v-model="refundMethod"  >
                  <a-select-option value="0">先退款</a-select-option>
                  <a-select-option value="1">后退款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否退票" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-select v-model="invoice" >
                  <a-select-option value="0">是</a-select-option>
                  <a-select-option value="1">否</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input v-model="backGoodsRemark"/>
              </a-form-item>

              <div>退货内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
                <a-select  @change="onChange3" v-model="accessoryId" >
                  <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
                <a-input   v-model="unityPrice"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input  v-model="accessoryNumber"  @blur="blur(accessoryNumber)" type="number" min="0"/>
              </a-form-item>



              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
                <a-input  v-model="orderPrice"  disabled="disabled"/>
              </a-form-item>

            </a-form>
            <a-button class="editable-add-btn" @click="handleAddTui">添加</a-button>
            <a-table bordered :dataSource="dataSource2" :columns="columns2">
              <template slot="totalPrice" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChangeTui(record.key, 'totalPrice', $event)" />
              </template>
              <template slot="remark" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChangeTui(record.key, 'remark', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource2.length"
                  title="确定删除吗?"
                  @confirm="() => onDeleteTui(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          <span>
              <a-upload
                name="file"
                :fileList="fileList1"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>

          <!--    调拨-->
          <div v-if="type==2 " >
            <div> 调拨单</div>
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调拨单号">
                <a-input v-model="shippingNo" disabled="disabled"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调出仓库" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-input   v-model="invoiceNmae"  disabled="disabled" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="调向仓库" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-select  @change="onchage44" v-model="storeId" >
                  <a-select-option   v-for=" item in storeType10" :value="item.storeId">{{item.storeName}}</a-select-option>
<!--                  <a-select-option   v-for=" item in storeType9" :value="item.storeId">{{item.storeName}}</a-select-option>-->
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结算方式" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-select @change="onChange2"  v-model="payment"  >
                  <a-select-option value="0">先付款</a-select-option>
                  <a-select-option value="1">后付款</a-select-option>
                  <a-select-option value="2">配发</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否退票" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-select v-model="invoice" >
                  <a-select-option value="0">不开票</a-select-option>
                  <a-select-option value="1">开票</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需求时间" style="position: relative">
                <span style="color: red;position: absolute;left: -78px;">*</span>
                <a-date-picker  @change="onChangeTiem"  />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input v-model="shippingRemark"/>
              </a-form-item>
              <div>调拨内容</div>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
                <a-select  @change="onChange3" v-model="accessoryId" >
                  <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单价">
                <a-input   v-model="unityPrice"   />
              </a-form-item>

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input  v-model="accessoryNumber"  @blur="blur(accessoryNumber)" type="number" min="0"/>
              </a-form-item>

<!--              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件总价">-->
<!--                <a-input   v-model="price2"  @click="clickMe" />-->
<!--              </a-form-item>-->

              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总金额">
                <a-input  v-model="orderPrice"  disabled="disabled"/>
              </a-form-item>

<!--              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">-->
<!--                <a-input   v-model="remark" />-->
<!--              </a-form-item>-->
            </a-form>
            <a-button class="editable-add-btn" @click=" handleTiaoBo">添加</a-button>
            <a-table bordered :dataSource="dataSource3" :columns="columns3">
              <template slot="totalPrice" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChangeBo(record.key, 'totalPrice', $event)" />
              </template>
              <template slot="remark" slot-scope="text, record">
                <editable-cell :text="text" @change="onCellChangeBo(record.key, 'remark', $event)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="dataSource3.length"
                  title="确定删除吗?"
                  @confirm="() => onDeleteBo(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </a-table>

            <span>
              <a-upload
                name="file"
                :fileList="fileList1"
                :action="uploadUrlb2"
                :headers="headers"
                @change="uploadChange"
                showUploadList="false"
              >
                <a-button  class="twobtn" style="margin-left: 10px;margin-bottom: 20px" type="primary">上传附件</a-button>
              </a-upload>
        </span>

          </div>
            <!--    报损-->
            <div v-if="type==3 " >
              <div>报损单</div>
              <a-form :form="form">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损单号">
                  <a-input v-model="faultyNo" disabled="disabled"/>
                </a-form-item>


                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="库存类型">

                  <a-select v-model="storeType"  @change="onChangeBao">
                    <a-select-option value="0">主库</a-select-option>
                    <a-select-option value="1">机构分库</a-select-option>
                    <a-select-option value="2">师傅分库</a-select-option>
                  </a-select>

                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损仓库">
<!--                  <a-input  v-model="storeId"/>-->
                  <a-select  @change="onchage45" v-model="storeId" >
                    <a-select-option   v-for=" item in selectstore3" :value="item.storeId">{{item.storeName}}</a-select-option>
                  </a-select>
                </a-form-item>

                <div>报损内容</div>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
                  <a-select  @change="onChange3" v-model="accessoryId" >
                    <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损数量">
                  <a-input   v-model="accessoryNumber"   />
                </a-form-item>

                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损原因">
                  <a-input  v-model="faultyRemark" />
                </a-form-item>

                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="损失承担方">
                  <a-select v-model="lossBearingParty" >
                    <a-select-option value="0">主库</a-select-option>
                    <a-select-option value="1">分库</a-select-option>
                    <a-select-option value="2">供应商</a-select-option>
                  </a-select>
<!--                  <a-input  v-model="lossBearingParty"  @click="clickMe" />-->
                </a-form-item>

                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="损失承担人">
                  <a-input v-model="lossBearers"  />
                </a-form-item>

                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任人">
                  <a-input v-model="personLiable" />
                </a-form-item>
              </a-form>
              <a-button class="editable-add-btn" @click="handleAddBao">添加</a-button>
              <a-table bordered :dataSource="dataSource4" :columns="columns4" :scroll="{ x: '200px'}">
                <template slot="personLiable" slot-scope="text, record">
                  <editable-cell :text="text" @change="onCellChange(record.key, 'personLiable', $event)" />
                </template>
                <template slot="faultyRemark" slot-scope="text, record">
                  <editable-cell :text="text" @change="onCellChange(record.key, 'faultyRemark', $event)" />
                </template>
                <template slot="operation" slot-scope="text, record">
                  <a-popconfirm
                    v-if="dataSource4.length"
                    title="确定删除吗?"
                    @confirm="() => onDelete4(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </div>

      <!--    查看-->
      <div v-if="type==4">

        <div>报损单</div>
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损单号">
            <a-input v-model="faultyNo" disabled="disabled"/>
          </a-form-item>


          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="库存类型">

            <a-select  v-model="storeType"  @change="onChangeBao" disabled="disabled">
              <a-select-option value="0">主库</a-select-option>
              <a-select-option value="1">机构分库</a-select-option>
              <a-select-option value="2">师傅分库</a-select-option>
            </a-select>

          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损仓库">
            <!--                  <a-input  v-model="storeId"/>-->
            <a-select  @change="onchage45" v-model="storeId" disabled="disabled" >
              <a-select-option   v-for=" item in selectstore3" :value="item.storeId">{{item.storeName}}</a-select-option>
            </a-select>
          </a-form-item>

        </a-form>
        <a-button disabled="disabled" class="editable-add-btn" @click="handleAddBao">添加</a-button>
        <a-table bordered :dataSource="dataSource4" :columns="columns4" disabled="disabled">
          <template slot="personLiable" slot-scope="text, record">
            <editable-cell :text="text" @change="onCellChange(record.key, 'personLiable', $event)" disabled="disabled" />
          </template>
          <template slot="faultyRemark" slot-scope="text, record">
            <editable-cell :text="text" @change="onCellChange(record.key, 'faultyRemark', $event)" disabled="disabled" />
          </template>
          <template slot="operation" slot-scope="text, record">
            <a-popconfirm
              v-if="dataSource4.length"
              title="确定删除吗?" disabled="disabled"
              @confirm="() => onDelete4(record.key)"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
        <span style="display: flex;justify-content: flex-end;">
<!--         <a-button style="margin-right: 20px;" @click="handleSubmit2" >取消</a-button>-->
<!--      <a-button @click="handleSubmit" :loading="iconLoading" type="primary">确认</a-button>-->
        </span>
      </div>

      <!-- 审核-->
      <div v-if="type==5">

        <div>报损单</div>
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损单号">
            <a-input v-model="faultyNo" disabled="disabled"/>
          </a-form-item>


          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="库存类型">

            <a-select  v-model="storeType"  @change="onChangeBao" disabled="disabled">
              <a-select-option value="0">主库</a-select-option>
              <a-select-option value="1">机构分库</a-select-option>
              <a-select-option value="2">师傅分库</a-select-option>
            </a-select>

          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损仓库">
            <!--                  <a-input  v-model="storeId"/>-->
            <a-select  @change="onchage45" v-model="storeId" disabled="disabled" >
              <a-select-option   v-for=" item in selectstore3" :value="item.storeId">{{item.storeName}}</a-select-option>
            </a-select>
          </a-form-item>
          <div>报损内容</div>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
            <a-select  @change="onChange3" v-model="accessoryId" disabled="disabled" >
              <a-select-option   v-for=" item in parts" :value="item.accessoryId">{{item.accessoryType}} _ {{item.accessoryName}} _ {{item.accessoryCategory}} _ {{item.accessorySpecification}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损数量">
            <a-input   v-model="accessoryNumber"  disabled="disabled" />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报损原因">
            <a-input  v-model="faultyRemark" disabled="disabled" />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="损失承担方">
            <a-select v-model="lossBearingParty" disabled="disabled" >
              <a-select-option value="0">主库</a-select-option>
              <a-select-option value="1">分库</a-select-option>
              <a-select-option value="2">供应商</a-select-option>
            </a-select>
            <!--                  <a-input  v-model="lossBearingParty"  @click="clickMe" />-->
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="损失承担人">
            <a-input v-model="lossBearers" disabled="disabled" />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任人">
            <a-input v-model="personLiable" disabled="disabled" />
          </a-form-item>
        </a-form>
        <a-button disabled="disabled" class="editable-add-btn" @click="handleAddBao">添加</a-button>
        <a-table bordered :dataSource="dataSource4" :columns="columns4"  :scroll="{ x: '1600px'}"  disabled="disabled">
          <template slot="personLiable" slot-scope="text, record">
            <editable-cell :text="text" @change="onCellChange(record.key, 'personLiable', $event)" disabled="disabled" />
          </template>
          <template slot="faultyRemark" slot-scope="text, record">
            <editable-cell :text="text" @change="onCellChange(record.key, 'faultyRemark', $event)" disabled="disabled" />
          </template>
          <template slot="operation" slot-scope="text, record">
            <a-popconfirm
              v-if="dataSource4.length"
              title="确定删除吗?" disabled="disabled"
              @confirm="() => onDelete4(record.key)"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
        </a-table>

        <a-row>
          <a-col :span="10"></a-col>
          <a-col :span="6">
            <a-button @click="warehousing2" type="primary">通过</a-button>
            <span>
                <a-button @click="returnGoods2" style="margin-left: 10px " type="primary">未通过</a-button>
             </span>

          </a-col>
        </a-row>
      </div>

      <span style="display: flex;justify-content: flex-end;">
         <a-button style="margin-right: 20px;" @click="handleSubmit2" >取消</a-button>
      <a-button @click="handleSubmit" :loading="iconLoading" type="primary">确认</a-button>

     </span>

        </div>




  </a-modal>


</template>

<script>
  const EditableCell = {
    template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
    props: {
      text: String,
    },
    data() {
      return {
        value: this.text,
        editable: false,
      };
    },
    methods: {

      handleChange(e) {
        const value = e.target.value;
        this.value = value;
      },
      check() {
        this.editable = false;
        this.$emit('change', this.value);
      },
      edit() {
        this.editable = true;
      },
    },
  };
  const EditableCell2 = {
    template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-select
            v-model="value"
            style="width: 150px"
            optionFilterProp="children"
            @change="handleChange"
            @pressEnter="check"
          >
            <a-select-option value="1">锁安</a-select-option>
          </a-select>
          <a-input  @pressEnter="check" style="display: none" />
          <a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
          <a-icon type="close" @click="close"/>
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || text }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
    props: {
      text: String,
      list:String,
    },
    data() {
      return {
        value: this.text,
        editable: false,

      };
    },
    methods: {
      handleChange(val) {
        // if(val==1){
        //   val='锁安'
        // }else if(val==0){
        //   val='企业'
        // }
        // this.value = val;
      },
      check() {
        this.editable = false;
        this.$emit('change', this.value);
      },
      edit() {
        this.editable = true;
      },
      close(){
        console.log(this.list)
        this.value = this.text
        this.editable = false
      },
    },
    created(){

    }
  };

  // import TagSelectOption from '../../../components/TagSelect/TagSelectOption'
  let id = 0;
  import {getShippingFile,delShippingFile,updateLogisticsStatus,getMainStore,getStockByUserId,getonefaulty,auditOrder,selectStoreByStoreType,editbackorder,getonebackorder,shippinginaccessory,editshpping,getoneshpping,selectStorageAccessory, addallocation,addfaulty,addbackorder,addshpping,savePurchaseOrder,selectaccessory,selectenterprise,getonepurchaseorder,addpurchaseorder,editpurchaseorder,selectstore} from '@/api/accessory/commodity'
  import pick from 'lodash.pick'
  import {getDictMap} from "../../../utils/dict"
  import moment from 'moment'
  import { ACCESS_TOKEN } from '@/store/mutation-types'

  export default {

    name: 'commodityModal',
    props: {
    },
    components: {
      // TagSelectOption,
      EditableCell,
      EditableCell2,
    },
    data () {
      return {
        iconLoading: false,

        bankName1:[
          {id:'中国工商银行',name:'中国工商银行'},
          {id:'中国银行',name:'中国银行'},
          {id:'中国建设银行',name:'中国建设银行'},
          {id:'中国农业银行',name:'中国农业银行'},
          {id:'交通银行',name:'交通银行'},
          {id:'中国邮政储蓄银行',name:'中国邮政储蓄银行'},
          {id:'招商银行',name:'招商银行'},
          {id:'上海浦东发展银行',name:'上海浦东发展银行'},
          {id:'民生银行',name:'民生银行'},
          {id:'兴业银行',name:'兴业银行'},
          {id:'中信银行',name:'中信银行'},
          {id:'平安银行',name:'平安银行'},
          {id:'光大银行',name:'光大银行'},
          {id:'华夏银行',name:'华夏银行'},
          {id:'广发银行',name:'广发银行'},
          {id:'上海银行',name:'上海银行'},
          {id:'南京银行',name:'南京银行'},
          {id:'渤海银行',name:'渤海银行'},
          {id:'江苏银行',name:'江苏银行'},
          {id:'恒丰银行',name:'恒丰银行'},
          {id:'徽商银行',name:'徽商银行'},
          {id:'国家开发银行',name:'国家开发银行'},
          {id:'上海农村商业银行',name:'上海农村商业银行'},
          {id:'农村信用社',name:'农村信用社'},
          {id:'农村合作银行',name:'农村合作银行'},
        ],

        transportRemark:'',
        expectedDeliveryTime:null,
        shippingId:'',
        shippingFileId:'',
        forbiddenStatus:'',
        // 第一步下载文件
        fileLists:'',
        fileName:'',
        fileList1:[],
        // 第二步下载文件
        fileLists2:'',
        fileName2:'',
        fileList2:[],
        // 第三步下载文件
        fileLists3:'',
        fileName3:'',
        fileList3:[],
        // 第四步下载文件
        fileLists4:'',
        fileName4:'',
        fileList4:[],
        // 第五步下载文件
        fileLists5:'',
        fileName5:'',
        fileList5:[],


        columns7:[
          {
            title: '操作',
            width: '170px',
            dataIndex: 'action2',
            scopedSlots: { customRender: 'action2' }
          },
          {
            title: '文件名称',
            width: '200px',
            dataIndex: 'fileName',
            scopedSlots: { customRender: 'fileName' }
          },
        ],


        uploadUrlb2: process.env.VUE_APP_API_BASE_URL+'/dfs/upload?type=stock',

        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },

        operateTransport:'',
        operateType:'',
        completeStatus:'',
        // 主仓库Id
        inventoryType : '',
        // 主仓库名称
        invoiceNmae : '',
        // 报损仓库
        selectstore3:'',

        // 挑拨单 判断调拨内容是否隐藏
        judgment:'',
        // 物流
        logistics: [],
        orderPrice: '',
        // 采够单Id
        purchaseOrderId : '',
        accessoryName:'',
        accessoryType:'',
        accessoryCategory:'',
        accessorySpecification:'',
        dataSource:[
        ],
        dataSource2:[
        ],
        dataSource3:[
        ],
        dataSource4:[
        ],
        //退货
        originOrderType:'',
        //判断是先付款还是后付款
        dispatch:0,
        //退款备注
        backCompleteRemark:'',
        //退货单Id
        backOrderId:'',
        //工作流Id
        processInstanceId:'',
        //退货备注
        backGoodsRemark:'',
        //退货单号
        backOrderNo:'',
        //退货状态
        backCompleteStatus:'',
        //退款方式
        refundMethod:'',
        //仓库类型
        storeType:'',
        //订单号
        faultyNo:'',
        //责任人
        personLiable:'',
        //损失承担方
        lossBearingParty:'',
        //损失承担人
        lossBearers:'',
        //报损原因
        faultyRemark:'',
        types:'',
        types2:0,
        //调拨备注
        hippingRemark:'',
     //企业下拉框
        selectstore2:'',
       //订单完成时间
        orderCompletionTime:null,
        //备注(第五步)
        remark:'',
        //付款完成时间
        paymentCompletionTime:null,
        //付款完成备注
        paymentCompletionRemark:null,
        //户名
        accountName:'',
        //卡号
        accountNumber:'',
        //开户行
        bankName:'',
        //付款起始时间
        paymentTimeBegin:null,
        //付款结束时间
        paymentTimeEnd:null,
        //付款备注
        paymentRemark:'',
        //配件总价
        price2:'',
        //配件数量
        accessoryNumber:'',
        //配件单价
        unityPrice:'',
        //总价
        totalPrice:0,
        //配件备注
        //配件Id
        accessoryId:'',
        //配件列表Id
        parts2:'',
        //配件列表
        parts:'',
        //调货单状态
        shippingCompleteStatus:'',
        //调货/调拨状态
        allocateOrTransfer:'',
        //需求时间
        needTime:null,
        //是否开票
        invoice:'',
        //调货单号
        shippingNo:'',
        //调出仓库id
        originStoreId:'',
        //调向仓库ID
        storeId:'',
        //调拨备注
        shippingRemark:'',
        //支付方式
        payment:'',
        //列表选择的Id
        id:'',
        ids:'',
        //列表选择
        commonFlag:'',
        //判断显示
        type:'',
        //物流
        values:'',
        count: 0,
        count4: 0,
        count2: 0,
        count3:0,
        columns4: [
          {
            title: ' 操作',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },

          },

          {
            title: '配件类型',
            dataIndex: 'accessoryType',


          },
          {
            title: '配件名称',
            dataIndex: 'accessoryName',



          },
          {
            title: '配件型号',
            dataIndex: 'accessoryCategory',


          },
          {
            title: '配件规格',
            dataIndex: 'accessorySpecification',


          },
          {
            title: '报损数量',
            dataIndex: 'accessoryNumber',

          },
          {
            title: '损失承担方',
            dataIndex: 'lossBearingParty',

          },
          {
            title: '损失承担人',
            dataIndex: 'lossBearers',

          },
          {
            title: '责任人',
            dataIndex: 'personLiable',
            scopedSlots: { customRender: 'personLiable' },
          },
          {
            title: '报损原因',
            dataIndex: 'faultyRemark',
            scopedSlots: { customRender: 'faultyRemark' },
          },
        ],
        columns3: [
          {
            title: ' 操作',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
          },

          {
            title: '配件类型',
            dataIndex: 'accessoryType'
            // width: '20%',

          },
          {
            title: '配件名称',
            dataIndex: 'accessoryName'
            // width: '20%',

          },
          {
            title: '配件型号',
            dataIndex: 'accessoryCategory'
            // width: '20%',

          },
          {
            title: '配件规格',
            dataIndex: 'accessorySpecification'
            // width: '20%',

          },
          {
            title: '配件数量',
            dataIndex: 'accessoryNumber',
          },
          {
            title: '配件单价',
            dataIndex: 'unityPrice',
          },
          {
            title: '配件总价',
            dataIndex: 'totalPrice',
            scopedSlots: { customRender: 'totalPrice' },
          },
          {
            title: '配件备注',
            dataIndex: 'remark',
            scopedSlots: { customRender: 'remark' },
          },

        ],
        columns2: [
          {
            title: ' 操作',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
          },

          {
            title: '配件类型',
            dataIndex: 'accessoryType'
            // width: '20%',

          },
          {
            title: '配件名称',
            dataIndex: 'accessoryName'
            // width: '20%',

          },
          {
            title: '配件型号',
            dataIndex: 'accessoryCategory'
            // width: '20%',

          },
          {
            title: '配件规格',
            dataIndex: 'accessorySpecification'
            // width: '20%',

          },
          {
            title: '配件数量',
            dataIndex: 'accessoryNumber',
          },
          {
            title: '配件单价',
            dataIndex: 'unityPrice',
          },
          {
            title: '配件总价',
            dataIndex: 'totalPrice',
            scopedSlots: { customRender: 'totalPrice' },
          },
          {
            title: '配件备注',
            dataIndex: 'remark',
            scopedSlots: { customRender: 'remark' },
          },

        ],
        columns: [
          {
            title: ' 操作',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
          },

          {
            title: '配件类型',
            dataIndex: 'accessoryType'
            // width: '20%',

          },
          {
            title: '配件名称',
            dataIndex: 'accessoryName'
            // width: '20%',

          },
          {
            title: '配件型号',
            dataIndex: 'accessoryCategory'
            // width: '20%',

          },
          {
            title: '配件规格',
            dataIndex: 'accessorySpecification'
            // width: '20%',

          },
          {
            title: '配件数量',
            dataIndex: 'accessoryNumber',
          },
          {
            title: '配件单价',
            dataIndex: 'unityPrice',
          },
          {
            title: '配件总价',
            dataIndex: 'totalPrice',
            scopedSlots: { customRender: 'totalPrice' },
          },
          {
            title: '配件备注',
            dataIndex: 'remark',
            scopedSlots: { customRender: 'remark' },
          },

        ],
        current: 0,
        current2: 0,
        current3: 0,
        current4: 0,
        steps: [
          {
            title: '调货单',
            content: 'form-content',
          },
          {
            title: '付款申请',
            content: 'Second-content',
          },
          {
            title: '财务付款',
            content: 'Last-content',
          },
          {
            title: '物流发货',
            content: 'Last-content',
          },
          {
            title: '确认调货',
            content: 'Last-content',
          },
        ],
        steps2: [
          {
            title: '调货单',
            content: 'form-content',
          },
          {
            title: '物流发货',
            content: 'Second-content',
          },
          {
            title: '付款申请',
            content: 'Last-content',
          },
          {
            title: '财务付款',
            content: 'Last-content',
          },
          {
            title: '确认调货',
            content: 'Last-content',
          },
        ],
        steps3: [
          {
            title: '调货单',
            content: 'form-content',
          },
          {
            title: '物流发货',
            content: 'Second-content',
          },
          {
            title: '确认调货',
            content: 'Last-content',
          },
        ],
        visible: false,
        visible2: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        mdl: {},
        form: this.$form.createForm(this),
        form2: this.$form.createForm(this),
        formItemLayoutWithOutLabel: {
          wrapperCol: {
            xs: { span: 24, offset: 0 },
            sm: { span: 20, offset: 4 },
          },
        },
        storeType9:''
      }
    },
    beforeCreate () {
      this.form4 = this.$form.createForm(this, { name: 'dynamic_form_item' });
      this.form4.getFieldDecorator('keys', { initialValue: [], preserve: true });
    },
    async  created () {

      this.restaurantTypes = [];
      this.restaurantOperTypeMap = await getDictMap('delivery_company');
      this.restaurantOperTypeMap.forEach((value, key) => {
          this.restaurantTypes.push({code: key, label: value})
      })



    },
    methods: {
      moment,
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      handleSubmit2(){
        this.visible = false
      },


      blur(e){
        console.log("e",e)
        this.accessoryNumber =  this.accessoryNumber.replace(/\-/g,"");
      },


      delContract2(){
        getShippingFile({shippingId:this.shippingId}).then(res => {
          if(res.code==0){
            console.log(res)

            this.fileLists = res.rows[1]
            this.fileLists2 = res.rows[2]
            this.fileLists3 = res.rows[3]
            this.fileLists4 = res.rows[4]
            this.fileLists5 = res.rows[5]
          }else{
            this.$message.success(res.msg)
          }
        })
      },

      // 删除
      delContract(record){
        console.log("record",record)
        this.shippingId = record.shippingId
        const purchasePics2 ={
          shippingFileId :record.shippingFileId,
          delFlag :1,
        }
        delShippingFile(purchasePics2).then(res => {
          if(res.code==0){
            console.log(res)

            this.$message.success('删除成功')
            this.delContract2()
          }else{
            this.$message.success(res.msg)
          }
        })
      },

      //下载2
      delByIds(value){
        console.log("value",value)
        window.open(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + value.fileUrl + '&token=' + Vue.ls.get(ACCESS_TOKEN))
      },

      //上传
      uploadChange(info) {
        console.log(info)
        if(this.current==0 && this.current2==0 && this.current3==0) {
          this.fileList1 = info.fileList
        }else if(this.current==1 ||this.current2==1 ||this.current3==1){
          this.fileList2 = info.fileList
        }else if(this.current==2 ||this.current2==2 ||this.current3==2){
          this.fileList3 = info.fileList
        }else if(this.current==3 ||this.current2==3){
          this.fileList4 = info.fileList
        }else if(this.current==4 ||this.current2==4){
          this.fileList5 = info.fileList
        }else if(this.current==5 ||this.current2==5){
          this.fileList6 = info.fileList
        }
        let that=this
        if (info.file.status !== 'uploading') {

        }
        if (info.file.status === 'done') {
          console.log("info",info)
          if(this.current==0 && this.current2==0  && this.current3==0){
            this.fileName = info.file
            this.fileList1 = info.fileList
          }else if(this.current==1 ||this.current2==1 || this.current3==1){
            this.fileList2 = info.fileList
            this.fileName2 = info.file
          }else if(this.current==2 ||this.current2==2 || this.current3==2){
            this.fileList3 = info.fileList
            this.fileName3 = info.file
          }else if(this.current==3 ||this.current2==3){
            this.fileList4 = info.fileList
            this.fileName4 = info.file
          }else if(this.current==4 ||this.current2==4){
            this.fileList5 = info.fileList
            this.fileName5 = info.file
          }else if(this.current==5 ||this.current2==5){
            this.fileList6 = info.fileList
            this.fileName6 = info.file
          }

          // that.UpdataContract()
          that.$message.success(`上传成功`);
          // this.fileList1=[]
        } else if (info.file.status === 'error') {
          this.$message.error(`上传失败`);
          this.fileList1=[]
        }

      },

      // 启用
      enableContract(record){
        this.shippingId = record.shippingId
        console.log("record",record)
        const purchasePics2 ={
          shippingFileId:record.shippingFileId,
          forbiddenStatus:1,
        }
        delShippingFile(purchasePics2).then(res => {
          if(res.code==0){

            console.log(res)
            this.delContract2()
            this.$message.success('启用成功')
          }else{
            this.$message.success(res.msg)
          }
        })
      },

      // 禁用
      disableContract(record){
        this.shippingId = record.shippingId
        console.log("record",record)
        const purchasePics  ={
          shippingFileId:record.shippingFileId,
          forbiddenStatus:0
        }
        delShippingFile(purchasePics).then(res => {
          if(res.code==0){
            // this.forbiddenStatus = 0
            console.log(res)
            this.delContract2()
            this.$message.success('禁用成功')

          }else{
            this.$message.success(res.msg)
          }

        })
      },



      refreshOrder(record){
        this.purchaseOrderId = record.purchaseOrderId
        this.add()
      },


      refreshOrder2 (record) {
        this.refreshOrder()
      },

      //银行卡号正则表达式
      bankNum(rule, value, callback){
        const pwdRegex =  /^[1-9]\d{15,19}$/
        console.log(value)
        if(value==undefined||value.length==0){
          callback()
        }else if (!pwdRegex.test(value)) {
          callback(new Error('请输入正确的银行卡号'))
        }
        callback()
      },


      // 添加物流
      handleadd1() {
        console.log(11)
        // this.logistics =[]
        this.logistics.push({
          transportCode:'',
          transportNo:'',
          transportStatus:''
        });
      },

      // 移除添加
      removeTab1(item){
        let index = this.logistics.indexOf(item);
        if (index !== -1) { //当没有多余tab时就不再删除
          this.logistics.splice(index, 1)
        }
      },

      //获取配件状态
      onChange3(values){

        for(let k=0;k<this.parts.length;k++){
          if(this.parts[k].accessoryId==values){
            this.unityPrice=this.parts[k].unityPrice
          }
        }
          this.accessoryId = values
          let boxLis = this.parts
          for (let i = 0 ;i < boxLis.length ; i++) {
            if (boxLis[i].accessoryId == values) {
            //  this.accessoryId =  boxLis[i].accessoryId
              this.accessoryName =  boxLis[i].accessoryName
              this.accessoryType =  boxLis[i].accessoryType
              this.accessoryCategory =  boxLis[i].accessoryCategory
              this.accessorySpecification =  boxLis[i].accessorySpecification
            }
          }

      },
      //仓库下拉框
      onchage33(value){
        this.storeType9=[]
        this.storeId=undefined
        console.log(this.selectstore2,'this.selectstore2')
        for(let i=0;i<this.selectstore2.length;i++){
          if(this.selectstore2[i].storeId==value){
           this.payment=this.selectstore2[i].payment
           // this.storeType9=this.selectstore2
            this.storeType9.splice(i,1)
          }else{
            this.storeType9.push(this.selectstore2[i])
          }
        }

       // if(this.selectstore2.storeId == value) {
         this.originStoreId = value
         selectStorageAccessory({ storeId: value }).then(res => {
           this.parts = res.rows

         })
       // }
      },

     // 根据仓库类型查询仓库
      onChangeBao(value){
        selectStoreByStoreType({storeType:value}).then(res => {
          console.log(res)
          this.selectstore3 = res.rows


        })
      },
      onchage55(){

      },


      // 调向仓库
      onchage44(value){
          // console.log('this.onchage44' ,this.storeType9)
          // for(var i=0;i<this.storeType9.length;i++){
          //   if(this.storeType9[i].storeId==value){
          //     this.payment=this.storeType9[i].payment
          //
          //   }
          // }

        // selectStorageAccessory({storeId:value}).then(res => {
        //   console.log(res)
        //   this.parts =  res.rows
        //   console.log('parts',this.parts)
        //   for(let i=0;i< this.parts.length;i++){
        //     if( this.parts[i].storeId == value){
        //       this.storeId =   this.parts[i].storeId
        //       this.storeName =   this.parts[i].storeName
        //     }
        //   }
        //
        // })
      },
      // 报损 配件
      onchage45(value){
        this.storeId = value
        selectStorageAccessory({storeId:this.storeId}).then(res => {
          console.log(res)
          this.parts =  res.rows

          for(let i=0;i< this.parts.length;i++){
            if( this.parts[i].storeId == value){
              this.storeId =   this.parts[i].storeId
              this.storeName =   this.parts[i].storeName

            }
          }

        })
      },

      //报损 审核通过
      warehousing2(){
        const shipping= {
          // accessories:this.dataSource4,
          auditStatus:1,
          faultyId:this.orderId
        };
        auditOrder(shipping).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('保存成功')
            this.$emit('ok')
            this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        }).catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
      },

      //报损 审核未通过
      returnGoods2(){
        const shipping= {
          auditStatus:2,
          faultyId:this.orderId
        };
        auditOrder(shipping).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('保存成功')
            this.$emit('ok')
            this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        }).catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })

      },


      //入库
      warehousing(){

      },

      //出库
      returnGoods(){

        this.originOrderType=2
          this.originOrderId = this.originOrderId
        this.types = 1
        this.type = 1
        this.storeType9=[]
        for(let i=0;i<this.selectstore2.length;i++){
          if(this.selectstore2[i].storeId==this.originStoreId){
            this.payment=this.selectstore2[i].payment
            // this.storeType9=this.selectstore2
            this.storeType9.splice(i,1)
          }else{
            this.storeType9.push(this.selectstore2[i])
          }
        }
        console.log(  this.storeType9)
          console.log( this.types)
         console.log( this.type)

      },


      remove(k){
          const { form4 } = this;
          // can use data-binding to get
          const keys = form4.getFieldValue('keys');
          // We need at least one passenger
          if (keys.length === 1) {
            return;
          }
          // can use data-binding to set
          form4.setFieldsValue({
            keys: keys.filter(key => key !== k),
          });
          console.log(id)
      },

      add2(){
          const { form4 } = this;
          // can use data-binding to get
          const keys = form4.getFieldValue('keys');
          const nextKeys = keys.concat(id++);
          // can use data-binding to set
          // important! notify form to detect changes
          form4.setFieldsValue({
            keys: nextKeys,
          });
          console.log(id)
        },

      onChangeTiemBao(time, timeString) {
        this.orderCompletionTime = timeString
        console.log(time, timeString);
      },

      //订单完成时间
      onChangeTiem5(time, timeString) {
        this.orderCompletionTime = timeString
        console.log(time, timeString);
      },

      //预计到款时间
      onChangeTiem66(time, timeString) {
        this.expectedDeliveryTime = timeString
        console.log(time, timeString);
      },


      //付款完成时间
      onChangeTiem4(time, timeString) {
        this.paymentCompletionTime = timeString
        console.log(time, timeString);
      },
      //付款开始时间
      onChangeTiem2(time, timeString) {
        this.paymentTimeBegin = timeString
        console.log(time, timeString);
      },

      //付款结束时间
      onChangeTiem3(time, timeString) {
        this.paymentTimeEnd = timeString
        console.log(time, timeString);
      },

      //退货开始时间
      onChangeTiem22(time, timeString) {
        this.refundDateBegin = timeString
        console.log(time, timeString);
      },

      //退货结束时间
      onChangeTiem23(time, timeString) {
        this.refundDateEnd = timeString
        console.log(time, timeString);
      },
      //退款完成时间
      onChangeTiem24(time, timeString) {
        this.backCompleteTime = timeString
        console.log(time, timeString);
      },
      //确认退款完成时间
      onChangeTiem25(time, timeString) {
        this.orderCompletionTime = timeString
        console.log(time, timeString);
      },

      //计算总价
      clickMe(){

        //this.totalPrice = this.accessoryNumber*this.unityPrice
      },

// 需求时间
      onChangeTiem(time, timeString) {
        this.needTime = timeString
        console.log(time, timeString);
      },
     //获取付款方式
      onChange2(values){
        this.parts2 = values
        if(this.parts2 ==1){
          this.dispatch = 1
        } else if(this.parts2 ==2){
          this.dispatch = 2
        }
        console.log(values)
      },
      // 获取选择id
      onchange (values) {
        this.id = values
        console.log(values)
      },

      // 调货
      onCellChange (key, dataIndex, value) {
        if(dataIndex == "totalPrice"){

          for (var i = 0, total = 0; i <= this.dataSource.length; i++) {
            if (i == key) {
              this.dataSource[i].unityPrice =   Math.round((value/this.accessoryNumber) * 100) / 100;
              this.dataSource[i].totalPrice = value
              total += parseInt(this.dataSource[i].totalPrice)
            }


          }
          console.log(total)
          this.orderPrice = total
          console.log(this.orderPrice)
        }
        const dataSource = [...this.dataSource];
        const target = dataSource.find(item => item.key === key);
        if (target) {
          target[dataIndex] = value;
          this.dataSource = dataSource;
        }
      },
      onDelete(key) {
        const dataSource = [...this.dataSource];
        this.dataSource = dataSource.filter(item => item.key !== key);
        this.count = this.count-1
        if(key-1==0){
          this.dataSource = []
        }
      },

      // 退货
      onCellChangeTui (key, dataIndex, value) {
        if(dataIndex == "totalPrice"){

          for (var i = 0, total = 0; i <= this.dataSource2.length; i++) {
            if (i == key) {
              this.dataSource2[i].unityPrice =  ( value / this.accessoryNumber ).toFixed(2)
              this.dataSource2[i].totalPrice = value
              total += parseInt(this.dataSource2[i].totalPrice)
            }


          }
          console.log(total)
          this.orderPrice = total
          console.log(this.orderPrice)
        }
        const dataSource2 = [...this.dataSource2];
        const target = dataSource2.find(item => item.key === key);
        if (target) {
          target[dataIndex] = value;
          this.dataSource2 = dataSource2;
        }
      },
      onDeleteTui (key) {
        const dataSource2 = [...this.dataSource2];
        this.dataSource2 = dataSource2.filter(item => item.key !== key);
      },

      // 调拨
      onCellChangeBo (key, dataIndex, value) {
        if(dataIndex == "totalPrice"){

          for (var i = 0, total = 0; i <= this.dataSource3.length; i++) {
            if (i == key-1) {
              this.dataSource3[i].unityPrice =  Math.round(value/this.accessoryNumber * 100) / 100;
              this.dataSource3[i].totalPrice = value
              total += parseInt(this.dataSource3[i].totalPrice)
            }

          }
          console.log(total)
          this.orderPrice = total
          console.log(this.orderPrice)
        }
        const dataSource3 = [...this.dataSource3];
        const target = dataSource3.find(item => item.key === key);
        if (target) {
          target[dataIndex] = value;
          this.dataSource3 = dataSource3;
        }
      },
      onDeleteBo (key) {

        const dataSource3 = [...this.dataSource3];
        this.dataSource3 = dataSource3.filter(item => item.key !== key);
      },


      onDelete4 (key) {

        const dataSource4 = [...this.dataSource4];
        this.dataSource4 = dataSource4.filter(item => item.key !== key);
        this.key = key-1
      },

      // 调货
      handleAdd () {
       if(this.validator()) {
         return
       } else {
         console.log(this.unityPrice)
         console.log(this.accessoryNumber)
         console.log(this.accessoryNumber * this.unityPrice)
         this.totalPrice = this.accessoryNumber * this.unityPrice

         console.log(this.parts)
         var parts = this.parts
         console.log(parts)
         for (let i = 0; i < parts.length; i++) {
           console.log(parts.accessoryId)
           if (this.parts2 == parts[i].accessoryId) {
             var accessoryId = parts[i].accessoryName
           }
         }
         console.log(this.count)
         const { count, dataSource } = this;
         const newData = {
           accessoryId: this.accessoryId,
           accessoryName: this.accessoryName,
           accessoryType: this.accessoryType,
           accessoryCategory: this.accessoryCategory,
           accessorySpecification: this.accessorySpecification,
           key: count,
           //accessoryId: this.parts2,
           accessoryNumber: Number(this.accessoryNumber),
           unityPrice: Number(this.unityPrice),
           totalPrice: this.totalPrice,
           remark: this.remark
         };
         this.dataSource = [...dataSource, newData];
         console.log(this.dataSource)
         for (var  j = 0, total = 0; j < this.dataSource.length; j++) {
           total += parseInt(this.dataSource[j].totalPrice)
         }
       this.orderPrice = total
         console.log(this.orderPrice)
         //this.dataSource = dataSource;
         this.count = count + 1;
       }
      },
      //退货
      handleAddTui () {
        if (this.validator()) {
          return
        } else {
          console.log(this.unityPrice)
          console.log(this.accessoryNumber)
          console.log(this.accessoryNumber * this.unityPrice)
          this.totalPrice = this.accessoryNumber * this.unityPrice
          console.log(this.parts)
          var parts = this.parts
          console.log(parts)
          for (let i = 0; i < parts.length; i++) {
            console.log(parts.accessoryId)
            if (this.parts2 == parts[i].accessoryId) {
              var accessoryId = parts[i].accessoryName
            }
          }
          console.log(this.count2)
          const { count2, dataSource2 } = this;
          const newData = {
            key: count2,
            accessoryId: this.accessoryId,
            accessoryName: this.accessoryName,
            accessoryType: this.accessoryType,
            accessoryCategory: this.accessoryCategory,
            accessorySpecification: this.accessorySpecification,
            accessoryNumber: this.accessoryNumber,
            unityPrice: this.unityPrice,
            totalPrice: this.totalPrice,
            remark: this.remark
          };
          this.dataSource2 = [...dataSource2, newData];
          console.log(this.dataSource2)
          for (var  j = 0, total = 0; j < this.dataSource2.length; j++) {
            total += parseInt(this.dataSource2[j].totalPrice)
          }
          this.orderPrice = total
          console.log(this.orderPrice)
          //this.dataSource = dataSource;
          this.count2 = count2 + 1;
        }
      },
      //调拨
      handleTiaoBo () {
        if(this.validator()) {
          return
        } else {
          console.log(this.unityPrice)
          console.log(this.accessoryNumber)
          console.log(this.accessoryNumber * this.unityPrice)
          this.totalPrice = this.accessoryNumber * this.unityPrice

          console.log(this.parts)
          var parts = this.parts
          console.log(parts)
          for (let i = 0; i < parts.length; i++) {
            console.log(parts.accessoryId)
            if (this.parts2 == parts[i].accessoryId) {
              var accessoryId = parts[i].accessoryName
            }
          }
          console.log(this.count3)
          const { count3, dataSource3 } = this;
          const newData = {
            accessoryId: this.accessoryId,
            accessoryName: this.accessoryName,
            accessoryType: this.accessoryType,
            accessoryCategory: this.accessoryCategory,
            accessorySpecification: this.accessorySpecification,
            key: count3,
            //accessoryId: this.parts2,
            accessoryNumber: Number(this.accessoryNumber),
            unityPrice: Number(this.unityPrice),
            totalPrice: this.totalPrice,
            remark: this.remark
          };
          this.dataSource3 = [...dataSource3, newData];
          console.log(this.dataSource3)
          for (var  j = 0, total = 0; j < this.dataSource3.length; j++) {
            total += parseInt(this.dataSource3[j].totalPrice)
          }
          this.orderPrice = total
          console.log(this.orderPrice)
          //this.dataSource = dataSource;
          this.count3 = count3 + 1;
        }
      },

      // 报损
      handleAddBao () {
        if (this.validator()) {
          return
        } else {
          console.log(this.parts)
          var parts = this.parts
          console.log(parts)
          for (let i = 0; i < parts.length; i++) {
            console.log(parts.accessoryId)
            if (this.parts2 == parts[i].accessoryId) {
              var accessoryId = parts[i].accessoryName
            }
          }

        if(this.lossBearingParty==0 ) {
          this.lossBearingParty = '主库'
        }else if(this.lossBearingParty==1){
          this.lossBearingParty = '分库'
        }else{
          this.lossBearingParty = '供应商'
        }
          console.log(this.count)
          const { count4, dataSource4 } = this;
          const newData = {
            key: count4,
            accessoryName: this.accessoryName,
            accessoryType: this.accessoryType,
            accessoryCategory: this.accessoryCategory,
            accessorySpecification: this.accessorySpecification,
            accessoryId: this.accessoryId,
            accessoryNumber: this.accessoryNumber,
            personLiable: this.personLiable,
            lossBearingParty: this.lossBearingParty,
            lossBearers: this.lossBearers,
            faultyRemark: this.faultyRemark
          };
          this.dataSource4 = [...dataSource4, newData];
          console.log(this.dataSource4)

          //this.dataSource = dataSource;
          this.count4 = count4 + 1;
        }
      },


      // 先付款 下一步
      next (e) {
        if(this.type==0){
          this.allocateOrTransfer = 1
        }else if(this.type==2){
          this.allocateOrTransfer = 0
        }
        // 第一步
        if (this.current== 0) {
          console.log(this.dataSource)
          var dataSource2 = this.dataSource
          e.preventDefault()
          this.form.validateFields(() => {
            const shipping = {
              shippingNo: this.shippingNo,
              originStoreId: this.originStoreId,
              storeId: this.storeId,
              payment: this.payment,
              invoice: this.invoice,
              needTime: this.needTime,
              shippingRemark: this.shippingRemark,
              shippingCompleteStatus: 1,
              allocateOrTransfer: this.allocateOrTransfer,

              shippingId:this.shippingId,
              accessories: this.dataSource,

            };
            if(this.fileName){
              shipping.shippingFiles=[{
                fileName:this.fileName.name,
                completeStatus :0,
                fileUrl:this.fileName.response.url }]
            }
                   console.log(shipping.needTime)
            if(shipping.needTime ==null){
              this.$message.error('需求时间，不能为空')
            }else {
              if (shipping.needTime._i != null) {
                shipping.needTime = shipping.needTime._i
              }
              if (this.validator8()) {
                return true
              } else {

                console.log('Received values of form: ', shipping)
                console.log(shipping)
                //this.confirmLoading = true
                editshpping(shipping).then(res => {
                  console.log(res)
                  if (res.code === 0) {
                    this.$message.success('保存成功')
                    this.current++;
                    this.visible = false
                    this.$emit('ok',1)
                  } else {
                    this.$message.success(res.msg)
                  }
                }).catch(() => {
                  this.$message.error('系统错误，请稍后再试')
                })
              }
            }
          })
        }
        //  第二步
        else if ( this.current==1 ) {
          const shipping = {

            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
           // processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 2,


            accountName: this.accountName,
            accountNumber: this.accountNumber,
            bankName: this.bankName,
            paymentTimeBegin: this.paymentTimeBegin,
            paymentTimeEnd: this.paymentTimeEnd,
            paymentRemark: this.paymentRemark,

          };
          if(this.fileName2){
            shipping.shippingFiles=[{
              fileName:this.fileName2.name,
              completeStatus :1,
              fileUrl:this.fileName2.response.url }]
          }

          if(shipping.paymentTimeBegin ==null){
            this.$message.error('时间，不能为空')
          }else {
            if (shipping.paymentTimeBegin._i != null) {
              shipping.paymentTimeBegin = shipping.paymentTimeBegin._i
              shipping.paymentTimeEnd = shipping.paymentTimeEnd._i
            }
            if (this.validator4()) {
              return
            } else {
              editshpping(shipping).then(res => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.current++;
                  this.visible = false
                  this.$emit('ok',1)
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
            }
          }
        }
        //  第三步
        else if(this.current == 2) {
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment: this.payment,
            shippingId: this.shippingId,
            //  processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 3,
            paymentCompletionTime: this.paymentCompletionTime,
            paymentCompletionRemark: this.paymentCompletionRemark,

          };
          if(this.fileName3){
            shipping.shippingFiles=[{
              fileName:this.fileName3.name,
              completeStatus :2,
              fileUrl:this.fileName3.response.url }]
          }
          if(shipping.paymentCompletionTime ==null){
            this.$message.error('时间，不能为空')
          }else {
            if (shipping.paymentCompletionTime._i != null) {
              shipping.paymentCompletionTime = shipping.paymentCompletionTime._i
            }

            if (this.validator5()) {
              return
            } else {
              editshpping(shipping).then(res => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.current++;
                  this.visible = false
                  this.$emit('ok',1)
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                // this.$message.error('系统错误，请稍后再试')
              })
            }
          }
        }
        //  第四步
        else if(this.current==3) {
          const shipping = {
            allocateOrTransfer: 1,
            payment: this.payment,
            shippingId: this.shippingId,
            processInstanceId: this.processInstanceId,
            shippingCompleteStatus: 4,

            logistics: this.logistics,
            expectedDeliveryTime:this.expectedDeliveryTime,
            transportRemark:this.transportRemark
          };
          if(this.fileName4){
            shipping.shippingFiles=[{
              fileName:this.fileName4.name,
              completeStatus :3,
              fileUrl:this.fileName4.response.url }]
          }
          if(shipping.expectedDeliveryTime ==null){
            this.$message.error('时间，不能为空')
          }else {
            if (shipping.expectedDeliveryTime._i != null) {
              shipping.expectedDeliveryTime = shipping.expectedDeliveryTime._i
            }

            if (this.validator6()) {
              return
            } else {
              editshpping(shipping).then(res => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.current++;
                  this.visible = false
                  this.$emit('ok',1)
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
            }
          }
        }
        // 第五步
        else if(this.current==4){
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 5,
            orderCompletionTime:this.orderCompletionTime,
            remark:this.remark,
          };

          const shipping2= {
            shippingId:this.shippingId ,
            accessories:this.dataSource
          };
          if (this.validator7()) {
            return
          } else {
            shippinginaccessory(shipping2).then(res => {
              console.log(res)
              if (res.code === 0) {

              } else {
                this.$message.success(res.msg)
              }

              editshpping(shipping).then(res => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.visible = false
                  this.form.resetFields()
                  this.$emit('ok',1)
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
            })
          }
        }
      },
      //调货流程 返回
      prev () {
        if(this.type==0){
          this.allocateOrTransfer = 1
        }else if(this.type==2){
          this.allocateOrTransfer = 0
        }
        if(this.current ==0){
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            shippingCompleteStatus: 0,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current=0;
              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }
       else if(this.current==1){
          this.accountName = ''
          this.accountNumber = ''
          this.bankName = ''
            this.paymentTimeBegin = null
            this.paymentTimeEnd = null
          this.paymentRemark = ''

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            shippingCompleteStatus: 0,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current--;
              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })

        }else if(this.current==2){
          this.paymentCompletionTime = null
          this.paymentCompletionRemark = ''
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
           // processInstanceId:this.processInstanceId,
            shippingCompleteStatus:1,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current--;
              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }else if(this.current==3){
          this.logistics = []
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
           // processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 2,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current--;
              this.visible = false

              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }else if(this.current==4){

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
           // processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 3,

          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current--;
              this.visible = false

              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }else if(this.current==5){
          this.orderCompletionTime = null
          this.remark = ''

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            processInstanceId:this.processInstanceId,
            shippingCompleteStatus:4,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current--;

              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }
      },



      // 后付款 下一步
      next2 (e) {
        if(this.type==0){
          this.allocateOrTransfer = 1
        }else if(this.type==2){
          this.allocateOrTransfer = 0
        }
        // 第一步
        if (this.current2== 0) {
          console.log(this.dataSource)
          var dataSource2 = this.dataSource
          e.preventDefault()
          this.form.validateFields(() => {
            const shipping = {
              shippingNo: this.shippingNo,
              originStoreId: this.originStoreId,
              storeId: this.storeId,
              payment: this.payment,
              invoice: this.invoice,
              needTime: this.needTime,
              shippingRemark: this.shippingRemark,
              shippingCompleteStatus: 1,
              allocateOrTransfer: this.allocateOrTransfer,

              shippingId:this.shippingId,
              accessories: this.dataSource,

            };
            if(this.fileName){
              shipping.shippingFiles=[{
                fileName:this.fileName.name,
                completeStatus :0,
                fileUrl:this.fileName.response.url }]
            }
            if(shipping.needTime ==null ){
              this.$message.error('需求时间，不能为空')
            }else {
              if(shipping.needTime._i != null) {
                shipping.needTime = shipping.needTime._i
              }

              if (this.validator8()) {
                return true
              } else {
                console.log('Received values of form: ', shipping)
                console.log(shipping)
                //this.confirmLoading = true
                editshpping(shipping).then(res => {
                  console.log(res)
                  if (res.code === 0) {
                    this.$message.success('保存成功')
                    this.current2++;
                    this.visible = false
                    this.$emit('ok',1)
                  } else {
                    this.$message.success(res.msg)
                  }
                }).catch(() => {
                  this.$message.error('系统错误，请稍后再试')
                })
              }
            }
          })
        }
        //  第二步
        else if ( this.current2==1 ) {
          const shipping = {

            allocateOrTransfer: this.allocateOrTransfer,
            payment: this.payment,
            shippingId: this.shippingId,
            // processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 2,

            logistics: this.logistics,
          expectedDeliveryTime : this.expectedDeliveryTime,
            transportRemark:this.transportRemark


        };
          if(this.fileName2){
            shipping.shippingFiles=[{
              fileName:this.fileName2.name,
              completeStatus :1,
              fileUrl:this.fileName2.response.url }]
          }
          if(shipping.expectedDeliveryTime ==null){
            this.$message.error('时间，不能为空')
          }else {
            if (shipping.expectedDeliveryTime._i != null) {
              shipping.expectedDeliveryTime = shipping.expectedDeliveryTime._i
            }
            if (this.validator6()) {
              return
            } else {
              editshpping(shipping).then(res => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.current2++;
                  this.visible = false
                  this.$emit('ok',1)
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
            }
          }
        }
        //  第三步
        else if(this.current2 == 2){
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            //  processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 3,

            accountName: this.accountName,
            accountNumber: this.accountNumber,
            bankName: this.bankName,
            paymentTimeBegin: this.paymentTimeBegin,
            paymentTimeEnd: this.paymentTimeEnd,
            paymentRemark: this.paymentRemark,

          };
          if(this.fileName3){
            shipping.shippingFiles=[{
              fileName:this.fileName3.name,
              completeStatus :2,
              fileUrl:this.fileName3.response.url }]
          }

          if(shipping.paymentTimeBegin ==null){
            this.$message.error('时间，不能为空')
          }else {
            if (shipping.paymentTimeBegin._i != null) {
              shipping.paymentTimeBegin = shipping.paymentTimeBegin._i
              shipping.paymentTimeEnd = shipping.paymentTimeEnd._i
            }

            if (this.validator4()) {
              return
            } else {
              editshpping(shipping).then(res => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.current2++;
                  this.visible = false
                  this.$emit('ok',1)
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
            }
          }
        }
        //  第四步
        else if(this.current2==3){
          const shipping = {
            allocateOrTransfer: 1,
            payment:this.payment,
            shippingId:this.shippingId,
            processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 4,

            paymentCompletionTime: this.paymentCompletionTime,
            paymentCompletionRemark: this.paymentCompletionRemark,

          };
          if(this.fileName4){
            shipping.shippingFiles=[{
              fileName:this.fileName4.name,
              completeStatus :3,
              fileUrl:this.fileName4.response.url }]
          }

            if(shipping.paymentCompletionTime ==null){
              this.$message.error('时间，不能为空')
            }else {
              if (shipping.paymentCompletionTime._i != null) {
                shipping.paymentCompletionTime = shipping.paymentCompletionTime._i
              }

              if (this.validator5()) {
                return
              } else {
                editshpping(shipping).then(res => {
                  console.log(res)
                  if (res.code === 0) {
                    this.$message.success('保存成功')
                    this.current2++;
                    this.visible = false
                    this.$emit('ok',1)
                  } else {
                    this.$message.success(res.msg)
                  }
                }).catch(() => {
                  this.$message.error('系统错误，请稍后再试')
                })
              }
            }
        }
        // 第五步
        else if(this.current2==4){
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 5,
            orderCompletionTime:this.orderCompletionTime,
            remark:this.remark,
          };

          const shipping2= {
            shippingId:this.shippingId,
            accessories:this.dataSource2
          };
          if (this.validator7()) {
            return
          } else {
            shippinginaccessory(shipping2).then(res => {
              console.log(res)
              if (res.code === 0) {

              } else {
                this.$message.success(res.msg)
              }

              editshpping(shipping).then(res => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.visible = false
                  this.form.resetFields()
                  this.$emit('ok',1)
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
            })
          }
        }
      },
      // 后付款 返回
      prev2 () {
        if(this.type==0){
          this.allocateOrTransfer = 1
        }else if(this.type==2){
          this.allocateOrTransfer = 0
        }
        if(this.current2 ==0){
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            shippingCompleteStatus: 0,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current2=0;
              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }
        else if(this.current2==1){

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            shippingCompleteStatus: 0,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current2--;
              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })

        }else if(this.current2==2){

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            // processInstanceId:this.processInstanceId,
            shippingCompleteStatus:1,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current2--;
              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }else if(this.current2==3){
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            // processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 2,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current2--;

              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }else if(this.current2==4){

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            // processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 3,

          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current2--;
              this.visible = false

              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }else if(this.current2 ==5){

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            processInstanceId:this.processInstanceId,
            shippingCompleteStatus:4,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current2--;
              this.visible = false

              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }
      },

      // 配发 下一步
      next3 (e) {
        if(this.type==0){
          this.allocateOrTransfer = 1
        }else if(this.type==2){
          this.allocateOrTransfer = 0
        }
        // 第一步
        if (this.current3== 0) {
          console.log(this.dataSource)

          e.preventDefault()
          this.form.validateFields(() => {
            const shipping = {
              shippingNo: this.shippingNo,
              originStoreId: this.originStoreId,
              storeId: this.storeId,
              payment: this.payment,
              invoice: this.invoice,
              needTime: this.needTime,
              shippingRemark: this.shippingRemark,
              shippingCompleteStatus: 1,
              allocateOrTransfer: this.allocateOrTransfer,

              shippingId:this.shippingId,
              accessories: this.dataSource,

            };
            if(this.fileName){
              shipping.shippingFiles=[{
                fileName:this.fileName.name,
                completeStatus :0,
                fileUrl:this.fileName.response.url }]
            }

            if(shipping.needTime == null){
              this.$message.error('需求时间，不能为空')
            }else {
              if (shipping.needTime._i != null) {
                shipping.needTime = shipping.needTime._i
              }
              if (this.validator8()) {
                return true
              } else {
                console.log('Received values of form: ', shipping)
                console.log(shipping)
                //this.confirmLoading = true
                editshpping(shipping).then(res => {
                  console.log(res)
                  if (res.code === 0) {
                    this.$message.success('保存成功')
                    this.current3++;
                    this.visible = false
                    this.$emit('ok',1)
                  } else {
                    this.$message.success(res.msg)
                  }
                }).catch(() => {
                  this.$message.error('系统错误，请稍后再试')
                })
              }
            }
          })
        }
        //  第二步
        else if ( this.current3==1 ) {
          const shipping = {

            allocateOrTransfer: this.allocateOrTransfer,
            payment: this.payment,
            shippingId: this.shippingId,
            // processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 2,

            logistics: this.logistics,
            expectedDeliveryTime : this.expectedDeliveryTime,
            transportRemark:this.transportRemark

          };
          if(this.fileName2){
            shipping.shippingFiles=[{
              fileName:this.fileName2.name,
              completeStatus :1,
              fileUrl:this.fileName2.response.url }]
          }

          if(shipping.expectedDeliveryTime ==null){
            this.$message.error('时间，不能为空')
          }else {
            if (shipping.expectedDeliveryTime._i != null) {
              shipping.expectedDeliveryTime = shipping.expectedDeliveryTime._i
            }

            if (this.validator6()) {
              return
            } else {
              editshpping(shipping).then(res => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.current3++;
                  this.visible = false
                  this.$emit('ok',1)
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
            }
          }
        }
        //  第三步
        else if(this.current3 == 2){
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            processInstanceId:this.processInstanceId,
            shippingCompleteStatus:3,
            orderCompletionTime:this.orderCompletionTime,
            remark:this.remark,
          };

          const shipping2= {
            shippingId:this.shippingId ,
            accessories:this.dataSource3
          };

          if (this.validator7()) {
            return
          } else {
            shippinginaccessory(shipping2).then(res => {
              console.log(res)
              if (res.code === 0) {

              } else {
                this.$message.success(res.msg)
              }

              editshpping(shipping).then(res => {
                console.log(res)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.visible = false
                  this.form.resetFields()
                  this.$emit('ok',1)
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
            })
          }
        }
      },
      // 配发 返回
      prev3 () {
        if(this.type==0){
          this.allocateOrTransfer = 1
        }else if(this.type==2){
          this.allocateOrTransfer = 0
        }
        if(this.current3 ==0){
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            shippingCompleteStatus: 0,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current3=0;
              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }
        else if(this.current3==1){

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            shippingCompleteStatus: 0,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current3--;
              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })

        }else if(this.current3==2){

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            // processInstanceId:this.processInstanceId,
            shippingCompleteStatus:1,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current3--;
              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }else if(this.current3==3){
          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            // processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 2,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current3--;
              this.visible = false

              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }else if(this.current3==4){

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            // processInstanceId:this.processInstanceId,
            shippingCompleteStatus: 3,

          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current3--;
              this.visible = false

              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }else if(this.current3 ==5){

          const shipping = {
            allocateOrTransfer: this.allocateOrTransfer,
            payment:this.payment,
            shippingId:this.shippingId,
            processInstanceId:this.processInstanceId,
            shippingCompleteStatus:4,
          };
          editshpping(shipping).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.current3--;

              this.visible = false
              this.form.resetFields()
              this.$emit('ok',1)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }
      },





      add  (record) {
        console.log("add",record)
        this.fileLists=''
        this. fileName=''
        this.fileList1=[]
        this.current = 0
        this.current2 = 0
        this.current3 = 0

        if( this.purchaseOrderId != ''){
          this.commonFlag = '退货'
          this.id = 1
        }else{
          this.commonFlag = ''
          this.id = ''
        }
        console.log(1111111111)
        this.operateType = '',
        this.completeStatus =''
        this.storeType9 = []
        this.parts2 = ''
        this.parts = ''
        this.logistics = []
        this.judgment = ''
        this.types2 = ''
this.expectedDeliveryTime = ''
        this.orderPrice = ''

        this.dataSource = [
        ]
          this.dataSource2=[
          ]
          this.dataSource3=[
          ]
          this.dataSource4=[
          ]
          //退货
          this.originOrderType=''

          //退款备注
          this.backCompleteRemark=''
          //退货单Id
          this.backOrderId=''
          //工作流Id
          this.processInstanceId = ''
          //退货备注
          this.backGoodsRemark=''
          //退货单号
          this.backOrderNo=''
          //退货状态
          this.backCompleteStatus=''
          //退款方式
          this.refundMethod=''
          //仓库类型
          this.storeType=''
          //订单号
          this.faultyNo=''
          //责任人
          this.personLiable=''
          //损失承担方
          this.lossBearingParty=''
          //损失承担人
          this.lossBearers=''
          //报损原因
          this.faultyRemark=''
          this.types=''

          //调拨备注
          this.hippingRemark=''
          //企业下拉框
          // this.selectstore2:'',
          //订单完成时间
          this.orderCompletionTime=null
          //备注(第五步)
          this.remark=''
          //付款完成时间
          this.paymentCompletionTime=null
          //付款完成备注
          this. paymentCompletionRemark=''
          //户名
          this.accountName=''
          //卡号
          this.accountNumber=''
          //开户行
          this.bankName=''
          //付款起始时间
          this.paymentTimeBegin=null
          //付款结束时间
          this.paymentTimeEnd=null
          //付款备注
          this.paymentRemark=''
          //配件总价
          this.price2=''
          //配件数量
          this.accessoryNumber=''
          //配件单价
          this.unityPrice=''
          //总价
          // totalPrice:0,
          //配件备注
          this.remark=''
          //配件Id
          this.accessoryId=''
          //配件列表Id
          this.parts2=''
          //配件列表
          this.parts=''
          //调货单状态
          this.shippingCompleteStatus=''
          //调货/调拨状态
          this.allocateOrTransfer=''
          //需求时间
          this.needTime=null
          //是否开票
          this.invoice=''
          //调货单号
          this.shippingNo=''
          //调出仓库id
          this.originStoreId=''
          //调向仓库ID
          this.storeId=''
          //调拨备注
          this.shippingRemark=''
          //支付方式
          this.payment=''

          //物流
          this.values=''
          this. shippingId=''

          this.types=1
          this.originOrderType=0
          this.form.resetFields()
          this.type = 7
          this.form.resetFields()

          this.edit({ accessoryId: 0 })

          selectaccessory({}).then(res => {
            console.log(res)
            this.parts = res.rows
          })
          selectenterprise({}).then(res => {
            console.log(res)
            this.boxLis = res.rows
          })
          selectstore({}).then(res => {
            console.log(res)
            this.selectstore2 = res.rows
          })
      },

      edit (record) {

        // 第一步下载文件
        this.fileLists=''
        this.fileName=''
        this.fileList1=[]
        // 第二步下载文件
        this. fileLists2=''
        this. fileName2=''
        this.fileList2=[]
        // 第三步下载文件
        this.fileLists3=''
        this. fileName3=''
        this.fileList3=[]
        // 第四步下载文件
        this.fileLists4=''
        this. fileName4=''
        this. fileList4=[]
        // 第五步下载文件
        this. fileLists5=''
        this. fileName5=''
        this. fileList5=[],



      console.log('record',record)
      selectaccessory({}).then(res => {
      console.log(res)
      this.parts = res.rows
      })
      selectenterprise({}).then(res => {
       console.log(res)
       this.boxLis = res.rows
       })
       selectstore({}).then(res => {
        console.log(res)
        this.selectstore2 = res.rows
         this.storeType9 = res.rows
        })
        // if(record.accessoryId !=0 || record.accessoryId !=undefined ) {
        if (record.orderType == "调货单") {
          if(record.operateType == 0){
            this.type = 0
            this.types = 5
            this.operateType = record.operateType
            if(record.operateTransport ==2){
            this.operateTransport = 2
            }else{
              this.operateTransport = 3
            }
          }else {
            this.type = 0
            this.types = 0
          }
          this.shippingId = record.orderId
           const shipping = {
                  shippingId: record.orderId,
                };
                getoneshpping(shipping).then(res => {
                  console.log(res)
                  this.shippingNo = res.shippingNo
                    this.originStoreId = res.originStoreId
                    this.storeId = res.storeId
                    this.invoice = res.invoice
                  if(res.needTime !=null){
                    this.needTime = moment(res.needTime)
                  }else{
                    this.needTime = null
                  }

                    this.shippingRemark = res.shippingRemark
                    this.shippingCompleteStatus = res.shippingCompleteStatus
                    this.dataSource = res.accessories
                  this.totalPrice = res.orderPrice

                  if (res.payment ==0 ) {
                    this.fileLists = res.fileLists[0]
                    this.current  = parseInt(res.shippingCompleteStatus)
                    this.parts2 =  res.payment
                    this.dispatch = res.payment
                      this.payment= res.payment

                    if (parseInt(res.shippingCompleteStatus)  != 1) {
                      this.fileLists2 = res.fileLists[1]
                      console.log(this.current)
                      this.accountName = res.accountName
                      this.form2.setFieldsValue({
                        accountNumber: res.accountNumber,
                      })

                      // this.accountNumber = res.accountNumber
                      this.bankName = res.bankName
                      console.log(res.paymentTimeBegin,'res.paymentTimeBegin')
                      if(res.paymentTimeBegin != null){
                        this.paymentTimeBegin = moment(res.paymentTimeBegin)
                        this.paymentTimeEnd = moment(res.paymentTimeEnd)
                      }else{
                        this.paymentTimeBegin = null
                        this.paymentTimeEnd = null
                      }

                      this.paymentRemark = res.paymentRemark
                      if (parseInt(res.shippingCompleteStatus)  != 2 ) {
                        this.fileLists3 = res.fileLists[2]
                        console.log(this.current)
                        if(res.paymentCompletionTime !=null){
                          this.paymentCompletionTime = moment(res.paymentCompletionTime)
                        }else{
                          this.paymentCompletionTime = null
                        }

                        this.paymentCompletionRemark = res.paymentCompletionRemark
                        if (parseInt(res.shippingCompleteStatus) != 3) {
                          this.fileLists4 = res.fileLists[3]
                          this.logistics = res.logistics
                          if(res.expectedDeliveryTime !=null){
                            this.expectedDeliveryTime = moment(res.expectedDeliveryTime)
                          }else{
                            this.expectedDeliveryTime = null
                          }
                          this.transportRemark = res.transportRemark
                          if(parseInt(res.shippingCompleteStatus) != 4){

                            if(res.orderCompletionTime !=null){
                              this.orderCompletionTime = moment(res.orderCompletionTime)
                            }else{
                              this.orderCompletionTime = null
                            }

                            this.remark = res.remark
                            if(record.operateType == 0 ){
                              this.current  =4
                            }

                          }
                        }
                        }
                      }
                    } else if(res.payment ==1){
                    this.parts2 =  res.payment
                    this.dispatch = res.payment
                      this.payment= res.payment
                      this.current2  = parseInt(res.shippingCompleteStatus)
                    this.fileLists = res.fileLists[0]
                    if (parseInt(res.shippingCompleteStatus)  != 1) {
                      this.fileLists2 = res.fileLists[1]
                      this.logistics = res.logistics
                      if(res.expectedDeliveryTime !=null){
                        this.expectedDeliveryTime = moment(res.expectedDeliveryTime)
                      }else{
                        this.expectedDeliveryTime = null
                      }
                      this.transportRemark = res.transportRemark
                      if (parseInt(res.shippingCompleteStatus)  != 2 ) {
                        this.fileLists3 = res.fileLists[2]
                        this.accountName = res.accountName
                        this.accountNumber = res.accountNumber
                        this.bankName = res.bankName
                        if(res.paymentTimeBegin!=null){
                          this.paymentTimeBegin = moment(res.paymentTimeBegin)
                          this.paymentTimeEnd = moment(res.paymentTimeBegin)
                        }else{
                          this.paymentTimeBegin = null
                          this.paymentTimeEnd = null
                        }
                        this.paymentRemark = res.paymentRemark
                        if (parseInt(res.shippingCompleteStatus) != 3) {
                          this.fileLists4 = res.fileLists[3]
                          if(res.paymentCompletionTime !=null){
                            this.paymentCompletionTime = moment(res.paymentCompletionTime)
                          }else{
                            this.paymentCompletionTime  = null
                          }
                          this.paymentCompletionRemark = res.paymentCompletionRemark
                          if(parseInt(res.shippingCompleteStatus) != 4){
                            if(res.orderCompletionTime !=null){
                              this.orderCompletionTime = moment(res.orderCompletionTime)
                            }else{
                              this.orderCompletionTime = null
                            }
                            this.remark = res.remark
                            if(record.operateType == 0 ){
                              this.current2  =4
                            }
                          }
                        }
                      }
                    }
                  } else if(res.payment ==2){
                    this.fileLists = res.fileLists[0]
                    this.parts2 =  res.payment
                    this.dispatch = res.payment
                      this.payment= res.payment
                      this.current3  = parseInt(res.shippingCompleteStatus)
                    if (parseInt(res.shippingCompleteStatus)  != 1) {
                      this.fileLists2 = res.fileLists[1]
                      this.logistics = res.logistics
                      if(res.expectedDeliveryTime !=null){
                        this.expectedDeliveryTime = moment(res.expectedDeliveryTime)
                      }else{
                        this.expectedDeliveryTime = null
                      }
                      this.transportRemark = res.transportRemark
                      if(parseInt(res.shippingCompleteStatus)  != 2){
                        if(res.orderCompletionTime != null){
                          this.orderCompletionTime = moment(res.orderCompletionTime)
                        } else{
                          this.orderCompletionTime =null
                        }
                        this.fileLists3 = res.fileLists[1]
                        this.remark = res.remark
                        if(record.operateType == 0 ){
                          this.current3  = 2
                        }
                      }
                    }

                  }
                })
              }
          //  }

        if(record.orderType == "报损单"){
          if(record.completeStatus=='已审核'){
            this.type = 4
            this.types=1
            this.id = 3
            this.operateType = 0
          }else if(record.completeStatus =='未审核' || record.completeStatus =='审核未通过' ){
            this.type = 5
            this.types=1
            this.id = 3
            this.auditStatus = 3
          }else{
            this.type = 3
            this.types=1
            this.id = 3
          }

          this.orderId = record.orderId
          const shipping = {
            faultyId: record.orderId,
          };
          getonefaulty(shipping).then(res => {
            console.log(res)
            this.faultyNo = res.faultyNo
      for(let i=0;i<res.accessories.length;i++){
        if(res.accessories[i].lossBearingParty==0 ) {
          res.accessories[i].lossBearingParty = '主库'
        }else if(res.accessories[i].lossBearingParty==1){
          res.accessories[i].lossBearingParty = '分库'
        }else{
          res.accessories[i].lossBearingParty = '供应商'
        }
      }


            this.dataSource4 = res.accessories
            this.storeType = res.storeType
            this.storeId = res.storeId
            selectStoreByStoreType({storeType:this.storeType}).then(res => {
              console.log(res)
              this.selectstore3 = res.rows
            })
          })
        }
            this.mdl = Object.assign(record)
            this.visible = true
            this.$nextTick(() => {
              this.form.setFieldsValue(pick(this.mdl, 'purchaseOrderId','storeId','purchaseOrderNo','needTime','intention','auditStatus','isPurchaseOrder','supplierId','accountName','accountNumber','bankName','totalPrice','payment','invoice','remark','expectedPaymentTimeBegin','expectedPaymentTimeEnd','paymentRemark','paymentCompletionTime','paymentCompletionRemark','expectedDeliveryTime','takeOverTime','transportRemark','consignee','procurementRemark','delFlag','forbiddenStatus','createBy','createTime','updateBy','updateTime'))
            })
          },


      // 确定提交
      handleSubmit (e) {

   if(this.operateType == '0'){

     if(this.operateTransport ==2){
       const shipping = {
         shippingId:this.shippingId,
         logistics:this.logistics
       };

       updateLogisticsStatus(shipping).then(res => {
     if(res.code == 0 ){
      console.log("res",res)
       this.visible = false
       this.$emit('ok',1)
     }
       })
       } else {
       this.visible = false
     }
     this.visible = false
   } else if ( this.type != 7 && this.types != 1) {
     this.visible = false
   }else {
     var date = new Date(); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
     var Y = date.getFullYear();
     var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1));
     var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate());
     var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours());
     var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes());
     var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds());
     var ms = ''
     if (date.getMilliseconds() < 10) {
       ms = '00' + date.getMilliseconds()
     } else if (date.getMilliseconds() < 100) {
       ms = '0' + date.getMilliseconds()
     } else {
       ms = date.getMilliseconds()
     }
     var num = Math.floor(Math.random() * 10);
     this.backOrderNo = `R${Y}${M}${D}${h}${m}${s}${ms}${num}`
     this.faultyNo = `L${Y}${M}${D}${h}${m}${s}${ms}${num}`
     if (this.id == 0) {
       this.shippingNo = `S${Y}${M}${D}${h}${m}${s}${ms}${num}`
     } else {
       this.shippingNo = `A${Y}${M}${D}${h}${m}${s}${ms}${num}`
     }

     this.visible2 = true
     if (this.id == 0 && this.id != '') {
       this.type = this.id
       if (this.types2 == 0) {

         this.types2 = 1
           getMainStore({}).then(res => {
             console.log('res', res)
             this.inventoryType = res.data.storeId
             this.invoiceNmae = res.data.storeName
             this.originStoreId = res.data.storeId
             selectStorageAccessory({ storeId: res.data.storeId }).then(res => {
               this.parts = res.rows
             })

           })

         this.storeType9=[]
         this.storeId=undefined
         console.log(this.selectstore2,'this.selectstore2')
         for(let i=0;i<this.selectstore2.length;i++){
           if(this.selectstore2[i].storeId==this.inventoryType){
             this.payment=this.selectstore2[i].payment
             // this.storeType9=this.selectstore2
             this.storeType9.splice(i,1)
           }else{
             this.storeType9.push(this.selectstore2[i])
           }
         }
         // selectstore({}).then(res => {
         //     console.log('getStockByUserId', res)
         //     this.storeType9 = res.rows
         //   })


       } else {
         // 调货
         this.types2 = 0
         console.log(this.dataSource)
         e.preventDefault()
         this.form.validateFields(() => {
           const shipping = {
             originOrderId: this.originOrderId,
             originOrderType: this.originOrderType,
             shippingNo: this.shippingNo,
             originStoreId: this.originStoreId,
             storeId: this.storeId,
             payment: this.payment,
             invoice: this.invoice,
             needTime: this.needTime,
             shippingRemark: this.shippingRemark,
             shippingCompleteStatus: 1,
             allocateOrTransfer: 1,

             accessories: this.dataSource,
             orderPrice: this.orderPrice,


           };
           if(this.fileName){
             shipping.shippingFiles=[{
               fileName:this.fileName.name,
               completeStatus :0,
               fileUrl:this.fileName.response.url }]
           }
           if(this.validator3()){
             return
           }else {

             console.log('Received values of form: ', shipping)
             console.log(shipping)
             this.iconLoading = true

             addshpping(shipping).then(res => {
               console.log(res)
               if (res.code === 0) {
                 this.$message.success('保存成功')
                 this.visible = false
                 this.iconLoading = false
                 this.form.resetFields()
                 this.$emit('ok')
               } else if (res.code === -1) {
                 this.$message.success('暂无库存')
                 this.iconLoading = false
               } else if (res.code === 1) {
                 this.$message.success('数量不足')
                 this.iconLoading = false
               } else {
                 this.$message.success(res.msg)
               }
               this.iconLoading = false
             }).catch(() => {
               this.$message.error('系统错误，请稍后再试')
             })
           }
         })
       }
     } else if (this.id == 1) {
       if (this.types2 == 0) {
         this.type = this.id
         this.types2 = 1
       } else {
         // 退货
         this.types2 = 0
         e.preventDefault()
         this.form.validateFields(() => {
           const purchaseOrder = {
             backOrderNo: this.backOrderNo,
             originStoreId: this.originStoreId,
             storeId: this.storeId,
             refundMethod: this.refundMethod,
             backCompleteStatus: 1,
             orderPrice: this.orderPrice,
             backGoodsRemark: this.backGoodsRemark,
             accessories: this.dataSource2,

           };
           if(this.fileName){
             purchaseOrder.files=[{
               fileName:this.fileName.name,
               completeStatus :0,
               fileUrl:this.fileName.response.url }]
           }

           if(this.validator3()){
             return
           }else {
             console.log('Received values of form: ', purchaseOrder)
             console.log(purchaseOrder)
             // this.confirmLoading = true
             this.iconLoading = true
             addbackorder(purchaseOrder).then(res => {
               console.log(res)
               if (res.code === 0) {
                 this.$message.success('保存成功')
                 this.iconLoading = false
                 this.visible = false
                 this.form.resetFields()

                 this.$emit('ok')
               } else {
                 this.$message.success(res.msg)
               }
               // this.confirmLoading = false
             }).catch(() => {
               this.$message.error('系统错误，请稍后再试')
             })
           }
         })
         this.visible2 = false
       }

     } else if (this.id == 2) {
       this.type = this.id
       if (this.types2 == 0) {
         this.types2 = 1

         getMainStore({}).then(res => {
           console.log('res', res)
           this.inventoryType = res.data.storeId
           this.invoiceNmae = res.data.storeName
           this.originStoreId = res.data.storeId
           selectStorageAccessory({ storeId: res.data.storeId }).then(res => {
             this.parts = res.rows
           })

         })


         getStockByUserId({}).then(res => {
           console.log('getStockByUserId', res)
           this.storeType10 = res.rows
         })

       } else {
         // 调拨
         this.types2 = 0
         e.preventDefault()
         this.form.validateFields(() => {
           const purchaseOrder = {
             originOrderId: this.originOrderId,
             originOrderType: this.originOrderType,
             shippingNo: this.shippingNo,
             originStoreId: this.originStoreId,
             storeId: this.storeId,
             payment: this.payment,
             invoice: this.invoice,
             needTime: this.needTime,
             shippingRemark: this.shippingRemark,
             shippingCompleteStatus: 0,
             allocateOrTransfer: 0,
             accessories: this.dataSource3,
             orderPrice: this.orderPrice,

           };
           if(this.fileName){
             purchaseOrder.shippingFiles=[{
               fileName:this.fileName.name,
               completeStatus :0,
               fileUrl:this.fileName.response.url }]
           }
           if(this.validator3()){
             return
           }else {
             console.log('Received values of form: ', purchaseOrder)
             console.log(purchaseOrder)
             this.iconLoading = true
             // this.confirmLoading = true
             addallocation(purchaseOrder).then(res => {
               console.log(res)
               if (res.code === 0) {

                 this.$message.success('保存成功')
                 this.$emit('ok')
                 this.visible = false
                 this.iconLoading = false
               } else {
                 this.$message.success(res.msg)
               }
               // this.confirmLoading = false
             }).catch(() => {
               this.$message.error('系统错误，请稍后再试')
             })
           }
         })
         this.visible2 = false
       }
     } else if (this.id == 3) {
       this.type = this.id
       if (this.types2 == 0) {
         this.types2 = 1
       } else {
         // 报损
         this.types2 = 0
         e.preventDefault()
         this.form.validateFields(() => {
           console.log(this.lossBearingParty)
           for (let k = 0; k < this.dataSource4.length; k++) {
             if (this.dataSource4[k].lossBearingParty == '主库') {
               this.dataSource4[k].lossBearingParty = '0'
             } else if (this.dataSource4[k].lossBearingParty == '分库') {
               this.dataSource4[k].lossBearingParty = '1'
             } else {
               this.dataSource4[k].lossBearingParty = '2'
             }
           }

           const purchaseOrder = {
             faultyNo: this.faultyNo,
             storeId: this.storeId,
             storeType: this.storeType,
             orderCompletionTime: this.orderCompletionTime,

             accessories: this.dataSource4,
           };
           console.log('Received values of form: ', purchaseOrder)
           console.log(purchaseOrder)

           if(this.validator10()){
             return
           }else {
             // this.confirmLoading = true
             this.iconLoading = true
             addfaulty(purchaseOrder).then(res => {
               console.log(res)
               if (res.code === 0) {
                 this.$message.success('保存成功')
                 this.visible = false
                 this.iconLoading = false
                 this.form.resetFields()
                 this.$emit('ok')
               } else {
                 this.$message.success(res.msg)
               }
               this.iconLoading = false
               // this.confirmLoading = false
             }).catch(() => {
               this.$message.error('系统错误，请稍后再试')
               this.iconLoading = false
             })
           }
         })
         this.visible2 = false
       }
     } else {
       this.$message.success('请选择配件类型')
     }
   }
      },


      validator8(){
        if (this.dataSource.length == 0) {
          this.$message.success('配件信息不能为空')
          return true
        }
      },


      validator2(){
        if(this.paymentTimeBegin =='' && this.paymentTimeBegin ==null && this.paymentTimeBegin ==undefined){
          this.$message.success('付款开始时间不能为空')
          return true
        }
      },


      // 确认调货
      validator7 () {
          if( this.orderCompletionTime ==null ){
            this.$message.success('订单完成时间不能为空')
            return true
          }
      },

      // 物流发货
      validator6 () {
        if(this.expectedDeliveryTime==null){
          this.$message.success('预计到货时间不能为空')
          return true
        }

        if(this.logistics.length ==0){
          this.$message.success('物流信息不能为空')
          return true
        }else {
          for (let i = 0; i < this.logistics.length; i++) {
            if (this.logistics[i].transportCode == '' || this.logistics[i].transportCode == null || this.logistics[i].transportCode == undefined) {
              this.$message.success('快递公司不能为空')
              return true
            }
            if (this.logistics[i].transportNo == '' || this.logistics[i].transportNo == null || this.logistics[i].transportNo == undefined) {
              this.$message.success('快递单号不能为空')
              return true
            }
            if (this.logistics[i].transportStatus === '' || this.logistics[i].transportStatus === null || this.logistics[i].transportStatus === undefined) {
              this.$message.success('物流状态不能为空')
              return true
            }
          }
        }
        // if(this.expectedDeliveryTime =='' || this.expectedDeliveryTime ==null || this.expectedDeliveryTime ==undefined){
        //   this.$message.success('预计到货时间不能为空')
        //   return true
        // }

      },
      // 财务付款
      validator5(){
        if( this.paymentCompletionTime ==null ){
          this.$message.success('付款完成时间不能为空')
          return true
        }

      },

      // 付款申请
      validator4(){
        if( this.accountName =='' || this.accountName ==null ||  this.accountName==undefined){
          this.$message.success('开户名不能为空')
          return true
        }
        if( this.accountNumber =='' || this.accountNumber ==null ||  this.accountNumber==undefined){
          this.$message.success('银行卡号不能为空')
          return true
        }
        if( this.bankName =='' || this.bankName ==null ||  this.bankName==undefined){
          this.$message.success('开户行不能为空')
          return true
        }
        if(this.paymentTimeBegin == null ){
          this.$message.success('付款开始时间不能为空')
          return true
        }
        if( this.paymentTimeEnd == null){
          this.$message.success('付款结束时间不能为空')
          return true
        }
      },
      validator10(){
        if (this.dataSource4.length == 0) {
          this.$message.success('报损内容不能为空')
          return true
        }
      },
     // 新增判断
      validator3(){
        if (this.shippingNo == '' || this.shippingNo == null || this.shippingNo  == undefined) {
          this.$message.success('调货单号不能为空')
          return true
        }
        if(this.type==1){

          if (this.dataSource2.length == 0) {
            this.$message.success('配件信息不能为空')
            return true
          }
          if (this.originStoreId == '' || this.originStoreId == null || this.originStoreId  == undefined) {
            this.$message.success('退货仓库不能为空')
            return true
          }
          if (this.storeId == '' || this.storeId == null || this.storeId  == undefined) {
            this.$message.success('收货仓库不能为空')
            return true
          }
        }else {
          if (this.originStoreId == '' || this.originStoreId == null || this.originStoreId == undefined) {
            this.$message.success('调出仓库不能为空')
            return true
          }
          if (this.storeId == '' || this.storeId == null || this.storeId == undefined) {
            this.$message.success('调向仓库不能为空')
            return true
          }
          if (this.needTime == '' || this.needTime == null || this.needTime == undefined) {
            this.$message.success('需求时间不能为空')
            return true
          }

          if (this.type==2) {
            if (this.dataSource3.length == 0) {
              this.$message.success('配件信息不能为空')
              return true
            }
          }else{

          if (this.dataSource.length == 0) {
            this.$message.success('配件信息不能为空')
            return true
          }
        }
        }



        if (this.payment == '' || this.payment == null || this.payment  == undefined) {
          this.$message.success('付款方式不能为空')
          return true
        }
        if (this.invoice == '' || this.invoice == null || this.invoice == undefined) {
          this.$message.success('是否开发票不能为空')
          return true
        }

      },

      validator () {
       // 调货单
        if(this.type== 0 || this.type==2){

          if (this.accessoryId == '' || this.accessoryId == null || this.accessoryId == undefined) {
            this.$message.success('配件不能为空')
            return true
          }
          if (this.unityPrice == '' || this.unityPrice == null || this.unityPrice == undefined) {
            this.$message.success('单价不能为空')
            return true
          }
          if (this.accessoryNumber == '' || this.accessoryNumber == null || this.accessoryNumber == undefined) {
            this.$message.success('数量不能为空')
            return true
          }

        } else if ( this.type==1){
          // 退货单

          if (this.accessoryId == '' || this.accessoryId == null || this.accessoryId == undefined) {
            this.$message.success('配件不能为空')
            return true
          }
          if (this.unityPrice == '' || this.unityPrice == null || this.unityPrice == undefined) {
            this.$message.success('单价不能为空')
            return true
          }
          if (this.accessoryNumber == '' || this.accessoryNumber == null || this.accessoryNumber == undefined) {
            this.$message.success('数量不能为空')
            return true
          }
        } else if (this.type==3) {
          if (this.faultyNo == '' || this.faultyNo == null || this.faultyNo  == undefined) {
            this.$message.success('报损单号不能为空')
            return true
          }
          if (this.accessoryId == '' || this.accessoryId == null || this.accessoryId == undefined) {
            this.$message.success('配件不能为空')
            return true
          }
          if (this.accessoryNumber  == '' || this.accessoryNumber  == null || this.accessoryNumber  == undefined) {
            this.$message.success('报损数量不能为空')
            return true
          }
          if (this.faultyRemark   == '' || this.faultyRemark   == null || this.faultyRemark   == undefined) {
            this.$message.success('  报损原因不能为空')
            return true
          }
          if (this.lossBearingParty   == '' || this.lossBearingParty   == null || this.lossBearingParty   == undefined) {
            this.$message.success('损失承担方不能为空')
            return true
          }
          if (this.lossBearers  == '' || this.lossBearers  == null || this.lossBearers == undefined) {
            this.$message.success('   损失承担人不能为空')
            return true
          }
          if (this.personLiable   == '' || this.personLiable   == null || this.personLiable   == undefined) {
            this.$message.success(' 责任人不能为空')
            return true
          }
          // if (this.storeId == '' || this.storeId == null || this.storeId  == undefined) {
          //   this.$message.success('收货仓库不能为空')
          //   return true
          // }
          // if (this.refundMethod == '' || this.refundMethod == null || this.refundMethod  == undefined) {
          //   this.$message.success('退款方式不能为空')
          //   return true
          // }
          // if (this.invoice == '' || this.invoice == null || this.invoice == undefined) {
          //   this.$message.success('是否退票不能为空')
          //   return true
          // }
          // if (this.accessoryId == '' || this.accessoryId == null || this.accessoryId == undefined) {
          //   this.$message.success('配件不能为空')
          //   return true
          // }
          // if (this.unityPrice == '' || this.unityPrice == null || this.unityPrice == undefined) {
          //   this.$message.success('单价不能为空')
          //   return true
          // }
          // if (this.accessoryNumber == '' || this.accessoryNumber == null || this.accessoryNumber == undefined) {
          //   this.$message.success('数量不能为空')
          //   return true
          // }
        }

      }


    },

    watch: {
      /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
    }
  }
</script>
<style>
  .editable-cell {
    position: relative;
  }

  .editable-cell-input-wrapper,
  .editable-cell-text-wrapper {
    padding-right: 24px;
  }

  .editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
  }

  .editable-cell-icon,
  .editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
  }

  .editable-cell-icon {
    line-height: 18px;
    display: none;
  }

  .editable-cell-icon-check {
    line-height: 28px;
  }

  .editable-cell:hover .editable-cell-icon {
    display: inline-block;
  }

  .editable-cell-icon:hover,
  .editable-cell-icon-check:hover {
    color: #108ee9;
  }

  .editable-add-btn {
    margin-bottom: 8px;
  }
</style>